import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import ToolsPopup from "./ToolsPopup";
import SubRecCandidates from "../../ReviewTools/SubRecCandidates";
import Tools from "../../services/toolsJson.json";
import {
  getWfPhasesBgColor,
  getFieldData,
  getWfPhasesColor,
  getFormatedNumber,
} from "../../services/appService";
import {
  loadCandidatesByFilter,
  getFilterCandidates,
  SendReminder,
  getReminderStatus,
  loadCandidateApps,
  getCandidateApps,
  filterCandidatesReceived,
  candidateAppsReceived,
  candidateBprmFormReceived,
  getCandidateBprmForm,
  loadCandidateBprmForm,
} from "../../app/store/candidate";
import {
  getComponentUserStatus,
  getToolsCount,
  loadComponentUserStatus,
  loadToolsCount,
  toolsCountReceived,
  componentUserStatusReceived,
} from "../../app/store/tools";
import {
  getApplication,
  loadApplication,
  getApplicationData,
  loadProcessBprmForm,
  getProccessBprmForm,
  processBprmFormReceived,
} from "../../app/store/application";
import { getAlert } from "../../services/appAlerts";
import CandidateInfo from "../../app/components/CandidateInfo";
import ApplicationInfo from "../../app/components/ApplicationInfo";
import PartnerInfo from "../../app/components/PartnerInfo";
import ClientAgencyInfo from "../../app/components/ClientAgencyInfo";
import ProjectInfo from "../../app/components/ProjectInfo";
import ToolList from "../../app/components/ToolList";
import TaskInfo from "../../app/components/TaskInfo";
import WorkflowElement from "../../app/components/WorkflowElement";
import JourneySteps from "../../app/components/JourneySteps";
import Document from "../PortalForms/Document";
import TimeLogManagement from "../../ReviewTools/TimeLogManagement";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import {
  getDocuments,
  getReqDocuments,
  loadDocuments,
  loadReqDocuments,
  updateReceivedDocStatus,
} from "../../app/store/documents";
import MessageWithApplicant from "../PortalForms/MessageWithApplicant";
import InternalReview from "../PortalForms/InternalReview";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import { getCurrentUser } from "../../app/store/auth";
import WorkflowMapPopup from "../WorkflowMapPopup";
import useDocDownload from "../../app/hooks/useDocDownload";
import Moment from "react-moment";
import {
  getPurchaseOrderDoc,
  getPurchaseOrders,
  loadPurchaseOrderDoc,
  loadPurchaseOrders,
  purchaseOrderDocReceived,
} from "../../app/store/purchaseOrder";
import ReceivedDocuments from "../../ReviewTools/ReceivedDocuments";
import config from "../../config.json";
import CandidateReqDoc from "./CandidateReqDoc";
import ReportingDocuments from "../../ReviewTools/ReportingDocuments";
import RateEncryptDecrypt from "../../services/RateEncryptDecrypt";
import AddEditDuration from "./AddEditDuration";
import AddEditRates from "./AddEditRates";
import ViewCandidate from "./ViewCandidate";
import AddSubcontractor from "./AddSubcontractor";
import EditPartner from "../SystemAdministration/ManagePartner/EditPartner";
import { getAddedDurationObj } from "../../app/store/duration";
import { getAddedRateObj } from "../../app/store/rates";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";
import {
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
} from "../../app/store/subcontractor";
import {
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
} from "../../app/store/recruiter";

export default function ReviewTask() {
  const newRoute = [
    { name: "Onboarding and Contracts", url: "" },
    { name: "Candidates", url: "/ListCondidate/application" },
  ];

  const [selectedTask, setSelectedTask] = useState("");
  const [candidateObj, setCandidateObj] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [appType, setAppType] = useState("");
  const [type, setType] = useState("");
  const [module, setModule] = useState("");
  const [currentTask, setCurrentTask] = useState("");
  const [selectedApp, setSelectedApp] = useState("");
  const [parentApp, setParentApp] = useState("");

  const [componentList, setComponentList] = useState([]);

  const [reAssignShowHide, setReAssignShowHide] = useState(false);
  const [journeyShowHide, setJourneyShowHide] = useState(true);
  const [toolShowHide, setToolShowHide] = useState(false);
  const [sectionShowHide, setSectionShowHide] = useState(false);
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [toolObj, setToolObj] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [apiCallCount, setApiCallCount] = useState(0);
  const [actionType, setActionType] = useState("");
  const [wfForm, setWfForm] = useState(null);
  const [workflowShowHide, setWorkflowShowHide] = useState(null);
  const [tableShowHide, setTableShowHide] = useState(false);
  const [showHideReportingDocs, setShowHideReportingDocs] = useState(false);
  const [candidateEditType, setCandidateEditType] = useState("");
  const [summaryPopupType, setSummaryPopupType] = useState("");
  const [summaryPopupShowHide, setSummaryPopupShowHide] = useState(false);
  const [showSummaryGrid, setShowSummaryGrid] = useState(false);
  const [showReviewTools, setShowReviewTools] = useState(true);
  const [loadingForm, setLoadingForm] = useState(false);

  const [candidateWfForm, setCandidateWfForm] = useState(null);
  const [candidateWfTask, setCandidateWfTask] = useState(null);
  const [candidateWfId, setCandidateWfId] = useState(0);
  const [candidateUpdatedStateData, setCandidateUpdatedStateData] = useState(null);

  const [subcontractorWfForm, setSubcontractorWfForm] = useState(null);
  const [subcontractorWfTask, setSubcontractorWfTask] = useState(null);
  const [recruiterWfForm, setRecruiterWfForm] = useState(null);
  const [recruiterWfTask, setRecruiterWfTask] = useState(null);
  const [subcontractorUpdatedStateData, setSubcontractorUpdatedStateData] = useState(null);
  const [recruiterUpdatedStateData, setRecruiterUpdatedStateData] = useState(null);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const toolsCountSelector = useSelector(getToolsCount);
  const proccessBprmFormSelector = useSelector(getProccessBprmForm);
  const candidatesSelector = useSelector(getFilterCandidates);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const addedDurationObjSelector = useSelector(getAddedDurationObj);
  const addedRateObjSelector = useSelector(getAddedRateObj);
  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentUser = getCurrentUser();
  const state = location?.state;
  const lastProcessedSelectorRef = React.useRef(null);
  const reviewToolsRef = React.useRef(null);

  useEffect(() => {
    // Reset state before loading new candidate/partner to prevent stale flashing
    setSelectedApp("");
    setWfForm(null);
    setLoadingForm(false);
    setSelectedTask("");
    setCurrentTask("");
    setCandidateObj("");
    setComponentList([]);
    lastProcessedSelectorRef.current = null;
    dispatch(filterCandidatesReceived([]));
    dispatch(candidateAppsReceived([]));
    dispatch(processBprmFormReceived(null));
    dispatch(toolsCountReceived([]));
    dispatch(componentUserStatusReceived([]));

    console.log("Location State: ", state);
    if (state?.item && state?.app?.ciid)
      dispatch(loadCandidateApps(state?.item.id, "admin", 1, state?.app?.ciid));

    if (state?.appType) setAppType(state?.appType);
    if (state?.item) setSelectedItem(state?.item);
    if (state?.module) setModule(state?.module);
    if (state?.parentApplication) setParentApp(state?.parentApplication);
    if (state?.type) setType(state?.type);
    if (state?.task) setCurrentTask(state?.task);
    if (state?.app) setSelectedApp(state?.app);

    if (state?.module === "Subcontractor")
      newRoute[1] = {
        name: "Subcontractors",
        url: "/ListSubcontractor/application",
      };
    if (state?.module === "Recruiter")
      newRoute[1] = { name: "Recruiters", url: "/Recruiter/application" };

    dispatch(setCurrentRoute(newRoute));
    dispatch(setCurrentPageTitle("Review Workflow Task"));
    setActionType("");

    return () => {
      dispatch(filterCandidatesReceived([]));
      dispatch(candidateAppsReceived([]));
      dispatch(processBprmFormReceived(null));
      dispatch(toolsCountReceived([]));
      dispatch(componentUserStatusReceived([]));
    };
  }, [location, dispatch]);

  useEffect(() => {
    const candidateId = state?.item?.id || state?.item?.performerid;
    if (state?.appType !== "partner" && candidateId) {
      getCandidateDetails(candidateId);
    }

    if (state?.task?.wiid > 0) {
      setSelectedTask(state.task.wiid);
      dispatch(loadToolsCount(state.task.ciid));
      dispatch(loadComponentUserStatus(currentUser?.id, state.task.ciid));
      // dispatch(loadDocuments(state.task.ciid));
      // dispatch(loadPurchaseOrders(state?.item.id));
      // dispatch(loadReqDocuments(state.task.ciid));
    }
  }, [location, currentUser?.id, dispatch]);

  useEffect(() => {
    const requestedCandidateId = state?.item?.id;
    if (candidatesSelector && candidatesSelector.length > 0 && requestedCandidateId) {
      const candidate = candidatesSelector[0];
      if (String(candidate?.id) === String(requestedCandidateId)) {
        setCandidateObj(candidate);
      } else {
        setCandidateObj("");
      }
    } else {
      setCandidateObj("");
    }
  }, [candidatesSelector, state?.item?.id]);

  useEffect(() => {
    if (addedDurationObjSelector) {
      setSelectedItem((prev) => {
        if (!prev || prev.duration === addedDurationObjSelector) return prev;
        return { ...prev, duration: addedDurationObjSelector };
      });
    }
  }, [addedDurationObjSelector]);

  useEffect(() => {
    if (addedRateObjSelector) {
      setSelectedItem((prev) => {
        if (!prev || prev.rates === addedRateObjSelector) return prev;
        return { ...prev, rates: addedRateObjSelector };
      });
    }
  }, [addedRateObjSelector]);

  useEffect(() => {
    if (candidateObj) {
      if (candidateObj.applications?.length > 0) {
        setCandidateUpdatedStateData(candidateObj.applications[0].applicationData);
      } else {
        setCandidateUpdatedStateData(candidateObj.performerData);
      }
    } else {
      setCandidateUpdatedStateData(null);
    }
  }, [candidateObj]);

  useEffect(() => {
    setCandidateWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector]);

  useEffect(() => {
    setSubcontractorWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector]);

  useEffect(() => {
    setRecruiterWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector]);

  useEffect(() => {
    if (appType === "partner") {
      const partnerData = selectedItem?.applications?.length > 0
        ? selectedItem.applications[0].applicationData
        : selectedItem?.performerData || null;
      setSubcontractorUpdatedStateData(partnerData);
    } else {
      const appData = candidateObj?.applications?.length > 0
        ? candidateObj.applications[0].applicationData
        : candidateObj?.performerData || null;
      setSubcontractorUpdatedStateData(appData);
    }
  }, [candidateObj, selectedItem, appType]);

  useEffect(() => {
    if (appType === "partner") {
      const partnerData = selectedItem?.applications?.length > 0
        ? selectedItem.applications[0].applicationData
        : selectedItem?.performerData || null;
      setRecruiterUpdatedStateData(partnerData);
    } else {
      const appData = candidateObj?.applications?.length > 0
        ? candidateObj.applications[0].applicationData
        : candidateObj?.performerData || null;
      setRecruiterUpdatedStateData(appData);
    }
  }, [candidateObj, selectedItem, appType]);

  const getCandidateDetails = async (candidateId) => {
    const frmBody = new FormData();
    frmBody.append("id", candidateId || "");
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody));
  };

  const loadCandidateOnboardingForm = (sourceCandidate) => {
    const entType = getFieldData(sourceCandidate?.performerData, "candidateonboardingform", "CandidateEntity");
    let appCiid = 0;
    if (sourceCandidate?.applications?.length > 0) {
      const allWfTasks = sourceCandidate?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }
    dispatch(candidateBprmFormReceived(null));
    if (entType === "C2C Basis") {
      setCandidateWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setCandidateWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis));
    }
    if (entType === "W2 Basis") {
      setCandidateWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setCandidateWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setCandidateWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
      setCandidateWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis));
    }
  };

  const loadSubcontractorOnboardingForm = (sourceSubcontractor) => {
    let appCiid = 0;
    if (sourceSubcontractor?.applications?.length > 0) {
      const allWfTasks = sourceSubcontractor.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }
    setSubcontractorWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
    dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
  };

  const loadRecruiterOnboardingForm = (sourceRecruiter) => {
    let appCiid = 0;
    if (sourceRecruiter?.applications?.length > 0) {
      const allWfTasks = sourceRecruiter.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }
    setRecruiterWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
    dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
  };

  useEffect(() => {
    if (toolsCountSelector && toolsCountSelector.length > 0) {
      setComponentList(Tools.filter((x) => x.display === true));
    } else {
      setComponentList([]);
    }
  }, [toolsCountSelector]);

  const handleJorneySteps = (wiid) => {
    const wfTask = app.workflowTasks.filter((x) => x.wiid === wiid);
    if (wfTask.length > 0) {
      if (
        wfTask[0].wfPhase !== "Application" &&
        wfTask[0].itemName !== "Contract Management" &&
        wfTask[0].wfPhase !== "Time Log" &&
        wfTask[0].wfPhase !== "Invoice"
      ) {
        setWfForm(null);
        setLoadingForm(true);
      } else {
        setWfForm(null);
        setLoadingForm(false);
      }
      dispatch(loadProcessBprmForm(wfTask[0].formId));
      setSelectedTask(wfTask[0].wiid);
      setCurrentTask(wfTask[0]);
    }
  };

  useEffect(() => {
    const hasSelectorChanged =
      lastProcessedSelectorRef.current !== candidateAppsSelector;
    lastProcessedSelectorRef.current = candidateAppsSelector;
    if (!hasSelectorChanged) {
      return;
    }

    if (candidateAppsSelector.length > 0) {
      const latestApp = candidateAppsSelector[0];
      setSelectedApp(latestApp);

      let wfTasks = latestApp.workflowTasks
        .filter(
          (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 2, //&& x.formType === "WF"
        )
        .sort((a, b) => a.orderNumber - b.orderNumber);

      if (wfTasks.length > 1)
        wfTasks = wfTasks.filter((x) => x.wfPhase !== "Application");

      if (wfTasks.length === 0) {
        wfTasks = latestApp.workflowTasks
          .filter(
            (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 4, //&& x.formType === "WF"
          )
          .sort((a, b) => b.orderNumber - a.orderNumber);
      }

      let latestTask = wfTasks[0];
      let filterContractTask = wfTasks.filter(
        (x) => x.itemName === "Contract Management",
      );
      if (filterContractTask.length > 0 && actionType !== "taskDone") {
        latestTask = filterContractTask[0];
      } else if (actionType !== "taskDone") {
        filterContractTask = latestApp.workflowTasks.filter(
          (x) => x.itemName === "Contract Management",
        );
        latestTask =
          filterContractTask.length > 0 ? filterContractTask[0] : latestTask;
      }

      let findCurrentTask = wfTasks.filter((x) => x.wiid === currentTask?.wiid);
      if (findCurrentTask.length > 0) {
        findCurrentTask = findCurrentTask[0];
      }

      if (
        latestTask &&
        (findCurrentTask?.id !== latestTask?.id || apiCallCount > 3)
      ) {
        if (!state?.task && currentTask === "") {
          setTimeout(() => {
            if (selectedItem?.id && latestTask?.ciid) {
              dispatch(
                loadCandidateApps(selectedItem.id, "admin", 1, latestTask.ciid),
              );
            }
          }, 3000);
        }
        setSelectedTask(latestTask.wiid);
        setCurrentTask(latestTask);
        if (latestTask.wfPhase !== "Application") {
          if (
            latestTask.itemName !== "Contract Management" &&
            latestTask.wfPhase !== "Time Log" &&
            latestTask.wfPhase !== "Invoice"
          ) {
            setWfForm(null);
            setLoadingForm(true);
          }
          if (latestTask.formId) {
            dispatch(loadProcessBprmForm(latestTask.formId));
          }
        }
      } else if (latestTask) {
        if (apiCallCount > 0 && apiCallCount <= 3) {
          setTimeout(() => {
            if (selectedItem?.id && currentTask?.ciid) {
              setApiCallCount(apiCallCount + 1);
              dispatch(
                loadCandidateApps(
                  selectedItem.id,
                  "admin",
                  1,
                  currentTask.ciid,
                ),
              );
            }
          }, 3000);
        }
      }
    } else if (appType !== "partner") {
      setSelectedApp("");
    }
  }, [
    candidateAppsSelector,
    actionType,
    currentTask,
    apiCallCount,
    state,
    selectedItem,
    dispatch,
    appType,
  ]);

  useEffect(() => {
    if (proccessBprmFormSelector) {
      setWfForm(proccessBprmFormSelector);
    } else {
      setWfForm(null);
    }
    setLoadingForm(false);
  }, [proccessBprmFormSelector]);

  const handleToolShowHide = (r, type) => {
    setUploadType(type);
    setToolShowHide(true);
    const comp = Tools.filter((x) => x.id === r);
    if (comp.length > 0) setToolObj(comp[0]);
  };

  const handleCompShowHide = (id) => {
    const comp = Tools.filter((x) => x.id === id);
    if (comp.length > 0) setToolObj(comp[0]);
  };

  const handleToolObjShowHide = (r, p) => {
    const comp = Tools.filter((x) => x.id === r);
    if (comp.length > 0) {
      if (app?.workflowTasks) {
        const allTasks = app.workflowTasks.filter((x) => x.wfPhase === p);
        if (allTasks.length > 0) {
          setWfForm(null);
          setSelectedTask(0);
        }
      }
      setToolObj(comp[0]);
    }
  };

  const handleNextTask = (btnType) => {
    setTimeout(() => {
      setSelectedApp("");
      setWfForm(null);
      setLoadingForm(false);
      setApiCallCount(1);
      setActionType("taskDone");
      if (selectedItem?.id && currentTask?.ciid) {
        dispatch(
          loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid),
        );
      }
    }, 3000);
  };

  const handleRefreshJourney = () => {
    setSelectedApp("");
    setWfForm(null);
    setLoadingForm(false);
    if (selectedItem?.id && currentTask?.ciid) {
      dispatch(
        loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid),
      );
    }
  };

  const handleReAssignSubmit = () => {
    setReAssignShowHide(false);
    setSelectedApp("");
    setWfForm(null);
    setLoadingForm(false);
    setApiCallCount(3);
    if (selectedItem?.id && currentTask?.ciid) {
      dispatch(
        loadCandidateApps(selectedItem.id, "admin", 1, currentTask.ciid),
      );
    }
  };

  const handleJourneyShowHide = () => {
    setJourneyShowHide(!journeyShowHide);
  };

  const handleShowHideSection = (status) => {
    setSectionShowHide(status);
  };

  const handleToolHide = () => {
    setToolShowHide(false);
    setToolObj("");
  };



  const handleToolRefresh = () => {
    const state = location?.state;
    if (state?.task?.ciid > 0) {
      dispatch(loadToolsCount(state.task.ciid));
      dispatch(loadComponentUserStatus(currentUser.id, state.task.ciid));
    }
  };

  const handleBackToList = () => {
    const returnTo = state?.returnTo;
    if (returnTo) {
      navigate(returnTo, {
        state: {
          restoreCandidateList: true,
          candidateListState: state?.candidateListState,
        },
      });
      return;
    }

    navigate(-1);
  };

  const handleWorkflowModalShowHide = (obj) => {
    setWorkflowShowHide(!workflowShowHide);
  };

  const handleSectionHideShow = (status) => {
    setTableShowHide(status);
  };

  let procType = type;
  let item = "";
  let app = "";
  let wfTask = "";
  let entType = "";

  if (selectedItem !== "") {
    item = selectedItem;
    entType = getFieldData(
      selectedItem?.performerData,
      "candidateonboardingform",
      "CandidateEntity",
    );
  }

  if (selectedApp !== "") app = selectedApp;

  wfTask = currentTask;
  const phaseClass =
    wfTask?.wfPhase === "Application"
      ? "btn-wf2-default"
      : getWfPhasesColor(wfTask?.wfPhase) || "btn-default";
  const summaryThemeClass = phaseClass.replace("btn-", "theme-");

  const getResolvedUserType = () => {
    if (
      module === "Subcontractor" ||
      module === "Recruiter" ||
      module === "Candidate"
    ) {
      return module;
    }
    const pData = item?.performerData || candidateObj?.performerData;
    if (pData) {
      if (
        pData.subcontractorenrollmentform ||
        getFieldData(pData, "subcontractorenrollmentform", "Company_Phone")
      ) {
        return "Subcontractor";
      }
      if (
        pData.recruiterenrollmentform ||
        getFieldData(pData, "recruiterenrollmentform", "Company_Phone")
      ) {
        return "Recruiter";
      }
      if (
        pData.candidateonboardingform ||
        getFieldData(pData, "candidateonboardingform", "CandidateEntity")
      ) {
        return "Candidate";
      }
    }
    if (item?.subcontractor) return "Subcontractor";
    if (item?.recruiter) return "Recruiter";
    if (appType === "partner") return "Subcontractor";
    return "Candidate";
  };

  const resolvedUserType = getResolvedUserType();
  const resolvedViewType = appType === "partner"
    ? (module === "Subcontractor" ? "subcontractorList" : "recruiterList")
    : "candidateList";

  const candidateName = item?.performername
    ? [item.performername, item.lastName].filter(Boolean).join(" ")
    : "";
  const reviewSubject =
    appType === "partner"
      ? item?.label || item?.name || item?.companyName || "Review Record"
      : candidateName || "Review Record";
  const reviewTitle =
    appType === "partner"
      ? `${resolvedUserType} Details`
      : reviewSubject;
  const summaryHeaderName =
    candidateName || item?.name || item?.label || item?.companyName || "";
  const summaryHeaderEmail =
    candidateObj?.performeremail ||
    candidateObj?.email ||
    item?.performeremail ||
    item?.email ||
    "";
  const summaryHeaderPhone =
    candidateObj?.contactNo ||
    item?.contactNo ||
    candidateObj?.companyPhone ||
    item?.companyPhone ||
    "";
  const summaryPopupDescription = getSummaryPopupDescription(summaryPopupType);
  const summaryWorkflowTask = app?.workflowTasks
    ? app.workflowTasks[app.workflowTasks.length - 1]
    : currentTask;
  const summaryAchType = appType === "partner" ? resolvedUserType : "Candidate";
  const heroInitials = (reviewSubject || "RR")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  const heroRecordType = resolvedUserType;
  const workflowLabel = app?.workflowId
    ? `Workflow #${app.workflowId}`
    : "Workflow";
  const phaseLabel =
    wfTask?.wfPhase === "Application" ? "Review" : wfTask?.wfPhase || "Task";
  const partnerContactName = item?.contact1
    ? [item.contact1.performername, item.contact1.lastName]
      .filter(Boolean)
      .join(" ")
      .trim()
    : "";
  const partnerContactStatus =
    item?.contact1?.isActive === true
      ? "Activated"
      : item?.contact1?.isActive === false
        ? "Deactivated"
        : "To Activate";
  const candidateAgency = item?.performerData
    ? getFieldData(item.performerData, "projectengagement", "AgencyName")
    : "";
  const isAppSubmitted = app?.appSubmitted ?? state?.app?.appSubmitted;
  const onboardingStatus = isAppSubmitted ? "Complete" : "Review";
  const displayCiid =
    app?.ciid || state?.app?.ciid || currentTask?.ciid || "N/A";
  const displayAppName =
    app?.applicationType ||
    state?.app?.applicationType ||
    "Onboarding Application";
  const partnerStatusClass =
    item?.contact1?.isActive === true
      ? "success"
      : item?.contact1?.isActive === false
        ? "danger"
        : "warning";
  const candidateActiveStatus =
    item?.isActive === true
      ? "Activated"
      : item?.isActive === false
        ? "Deactivated"
        : "To Activate";
  const candidateStatusClass =
    item?.isActive === true
      ? "success"
      : item?.isActive === false
        ? "danger"
        : "warning";

  const getOnboardingField = (fieldName) => {
    let val = getFieldData(
      candidateObj?.performerData,
      "candidateonboardingform",
      fieldName,
    );
    if (!val) {
      val = getFieldData(
        item?.performerData,
        "candidateonboardingform",
        fieldName,
      );
    }
    return val;
  };

  const getProjectField = (fieldName) => {
    let val = getFieldData(
      candidateObj?.performerData,
      "projectengagement",
      fieldName,
    );
    if (!val) {
      val = getFieldData(item?.performerData, "projectengagement", fieldName);
    }
    return val;
  };

  const getProjectValue = (fields) => {
    return fields
      .map((field) => getProjectField(field))
      .find((value) => value && value !== "");
  };

  const getAdminAgencyFee = () => {
    const feePer = getProjectField("State_Admin_Fee");
    const feeDo = getProjectField("State_Admin_Fee_Amount");

    if (
      feePer !== "" &&
      feePer !== "0" &&
      feePer !== undefined &&
      feePer !== null
    ) {
      return (
        <>
          State Admin Fee :{" "}
          <RateEncryptDecrypt rateData={feePer} startSymbol="" endSymbol="%" />
        </>
      );
    } else if (
      feeDo !== "" &&
      feeDo !== "0" &&
      feeDo !== undefined &&
      feeDo !== null
    ) {
      return (
        <>
          State Admin Fee : <RateEncryptDecrypt rateData={feeDo} />
        </>
      );
    }

    return null;
  };

  const getDocumentUploadType = (editType) => {
    if (editType === "doc_agency") return "agency";
    if (editType === "doc_msp") return "msp";
    if (editType === "doc_subcontractor") return "Subcontractor";
    if (editType === "doc_recruiter") return "Recruiter";
    return "Candidate";
  };

  const getDocumentPanelTitle = (editType) => {
    if (editType === "doc_agency") return "Agency Documents Management";
    if (editType === "doc_msp") return "MSP Documents Management";
    if (editType === "doc_subcontractor")
      return "Subcontractor Documents Management";
    if (editType === "doc_recruiter") return "Recruiter Documents Management";
    return "Candidate Documents Management";
  };

  const getSummaryPopupTitle = (editType) => {
    if (editType === "duration") return "Duration Details";
    if (editType === "rate") return "Rate Details";
    if (editType === "ach") return "ACH Information";
    if (editType === "insurance") return "Insurance Information";
    if (editType?.startsWith("po_")) return "Purchase Orders";
    if (editType?.startsWith("doc_") || editType === "document")
      return getDocumentPanelTitle(editType);
    if (editType?.startsWith("form_")) {
      const formType = editType.replace("form_", "");
      return `${formType.charAt(0).toUpperCase()}${formType.slice(1)} Onboarding Form`;
    }
    return "Summary Details";
  };

  const getSummaryPopupIcon = (editType) => {
    if (editType === "duration") return "fa-clock-o";
    if (editType === "rate") return "fa-dollar";
    if (editType === "ach") return "fa-bank";
    if (editType === "insurance") return "fa-shield";
    if (editType?.startsWith("po_")) return "fa-shopping-cart";
    if (editType?.startsWith("doc_") || editType === "document")
      return "fa-id-card-o";
    if (editType?.startsWith("form_")) return "fa-pencil-square-o";
    return "fa-info-circle";
  };

  function getSummaryPopupDescription(editType) {
    if (editType === "duration")
      return "Review engagement dates, assignment duration, and related timeline details.";
    if (editType === "rate")
      return "Review billing rates, pay rates, and commercial terms for this candidate.";
    if (editType === "ach")
      return "Review secure ACH information and onboarding payment details.";
    if (editType === "insurance") {
      if (appType === "partner") {
        return `Review insurance certificate and coverage details for this ${resolvedUserType?.toLowerCase()}.`;
      }
      return "Review insurance certificate and coverage details.";
    }
    if (editType?.startsWith("po_"))
      return "Generate, upload, and track purchase orders for this candidate.";
    if (editType?.startsWith("doc_") || editType === "document") {
      if (appType === "partner") {
        return `Review, upload, send, and manage ${resolvedUserType?.toLowerCase()} documents.`;
      }
      return "Review, upload, send, and manage candidate documents.";
    }
    if (editType?.startsWith("form_")) {
      if (appType === "partner") {
        return `Review onboarding form details submitted for this ${resolvedUserType?.toLowerCase()}.`;
      }
      return "Review onboarding form details submitted for this candidate.";
    }
    return "Review summary details.";
  }

  const formatUSPhoneNumber = (phoneNo) => {
    if (!phoneNo) return "";
    const cleaned = ("" + phoneNo).replace(/\D/g, "");
    const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[2]}) ${match[3]}-${match[4]}`;
    }
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phoneNo;
  };

  const handleSummaryPopupShow = (editType) => {
    setToolObj("");
    setCandidateEditType("");
    setSummaryPopupType(editType);
    setSummaryPopupShowHide(true);
    if (editType === "form_candidate" && candidateObj) {
      loadCandidateOnboardingForm(candidateObj);
    }
    if (editType === "form_subcontractor") {
      loadSubcontractorOnboardingForm(candidateObj?.subcontractor || selectedItem?.subcontractor || selectedItem);
    }
    if (editType === "form_recruiter") {
      loadRecruiterOnboardingForm(candidateObj?.recruiter || selectedItem?.recruiter || selectedItem);
    }
  };

  const handleSummaryPopupHide = () => {
    setSummaryPopupShowHide(false);
    setSummaryPopupType("");
  };

  const handleSummaryPurchaseRefresh = () => {
    if (item?.performerid > 0) {
      dispatch(loadPurchaseOrders(item.performerid));
    }
  };

  const handleSummaryPurchaseShowHide = () => {
    handleSummaryPopupHide();
  };

  const handleSummarySignUnsignPo = () => { };

  const renderSummaryPopupContent = () => {
    if (!item) return null;

    if (summaryPopupType === "duration") {
      return (
        <AddEditDuration
          handleDurationShowHide={handleSummaryPopupHide}
          selectedObj={item}
          editType="duration"
          hideHeader={true}
        />
      );
    }

    if (summaryPopupType === "rate") {
      return (
        <AddEditRates
          handleDurationShowHide={handleSummaryPopupHide}
          selectedObj={item}
          editType="rate"
          hideHeader={true}
        />
      );
    }

    if (summaryPopupType === "ach") {
      return (
        <AchInformation
          workflowTask={summaryWorkflowTask}
          app={app}
          candidateObj={candidateObj}
          item={item}
          setViewBprmFormShowHide={setViewBprmFormShowHide}
          achType={summaryAchType}
          viewType={resolvedViewType}
          setSelectedApp={setSelectedApp}
          onBack={handleSummaryPopupHide}
          hideHeader={true}
        />
      );
    }

    if (summaryPopupType === "insurance") {
      return (
        <InsuranseInformation
          workflowTask={summaryWorkflowTask}
          app={app}
          candidateObj={candidateObj}
          item={item}
          setViewBprmFormShowHide={setViewBprmFormShowHide}
          insuranceType={summaryAchType || module}
          viewType={resolvedViewType}
          setSelectedApp={setSelectedApp}
          onBack={handleSummaryPopupHide}
          hideHeader={true}
        />
      );
    }

    if (summaryPopupType?.startsWith("po_")) {
      const partnerType =
        summaryPopupType === "po_subcontractor" ? "Subcontractor" : "Recruiter";
      return (
        <PurchaseOrderPopup
          purchaseShowHide={true}
          handlePurchaseShowHide={handleSummaryPurchaseShowHide}
          candidateObj={item}
          workflowTask={summaryWorkflowTask}
          poOrderType="add"
          item={{ partnerType }}
          handleSignUnsignPo={handleSummarySignUnsignPo}
          handleRefreshPoOrders={handleSummaryPurchaseRefresh}
          renderType="generate"
          onBack={handleSummaryPopupHide}
          hideHeader={true}
        />
      );
    }

    if (
      summaryPopupType === "document" ||
      summaryPopupType?.startsWith("doc_")
    ) {
      return (
        <Document
          item={item}
          uploadType={getDocumentUploadType(summaryPopupType)}
          viewType={
            appType === "partner"
              ? module === "Subcontractor"
                ? "subList"
                : ""
              : "candidateList"
          }
          embedded={true}
          onBack={handleSummaryPopupHide}
          workflowTask={summaryWorkflowTask}
          app={app}
        />
      );
    }

    if (summaryPopupType?.startsWith("form_")) {
      const formType = summaryPopupType.replace("form_", "");
      if (formType === "subcontractor") {
        return (
          subcontractorWfForm ? (
            <div className="as-form-body">
              <div className="row p-3">
                <WorkflowElement
                  wfTask={subcontractorWfTask}
                  wfForm={subcontractorWfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={subcontractorUpdatedStateData}
                />
              </div>
            </div>
          ) : (
            <div className="wf-loading-container" style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "60px 20px",
              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
              margin: "40px auto",
              maxWidth: "480px"
            }}>
              <div className="wf-loader-spinner" style={{
                position: "relative",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <div className="spinner-double-ring" style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  border: "4px solid transparent",
                  borderTopColor: "#0f766e",
                  borderBottomColor: "#0f766e",
                  borderRadius: "50%",
                  animation: "spin 1.5s linear infinite"
                }} />
                <div className="spinner-inner-ring" style={{
                  position: "absolute",
                  width: "70%",
                  height: "70%",
                  border: "3px solid transparent",
                  borderLeftColor: "#2563eb",
                  borderRightColor: "#2563eb",
                  borderRadius: "50%",
                  animation: "spin-reverse 1.2s linear infinite"
                }} />
                <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
              </div>
              
              <p style={{
                margin: "20px 0 6px 0",
                color: "#0f172a",
                fontSize: "15px",
                fontWeight: 800,
                letterSpacing: "-0.01em"
              }}>
                Fetching Onboarding Schema
              </p>
              <p style={{
                margin: 0,
                color: "#64748b",
                fontSize: "12.5px",
                fontWeight: 500,
                textAlign: "center"
              }}>
                Please wait while we retrieve the Subcontractor onboarding form details.
              </p>
              
              <div style={{
                width: "120px",
                height: "3px",
                background: "#e2e8f0",
                borderRadius: "2px",
                marginTop: "16px",
                overflow: "hidden",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  height: "100%",
                  width: "40%",
                  background: "linear-gradient(90deg, #0f766e, #2563eb)",
                  borderRadius: "2px",
                  animation: "pulse-loader 1.5s infinite ease-in-out"
                }} />
              </div>

              <style dangerouslySetInnerHTML={{ __html: `
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                @keyframes spin-reverse {
                  0% { transform: rotate(360deg); }
                  100% { transform: rotate(0deg); }
                }
                @keyframes pulse-loader {
                  0% { left: -40%; }
                  50% { left: 100%; }
                  100% { left: -40%; }
                }
              `}} />
            </div>
          )
        );
      }
      if (formType === "recruiter") {
        return (
          recruiterWfForm ? (
            <div className="as-form-body">
              <div className="row p-3">
                <WorkflowElement
                  wfTask={recruiterWfTask}
                  wfForm={recruiterWfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={recruiterUpdatedStateData}
                />
              </div>
            </div>
          ) : (
            <div className="wf-loading-container" style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "60px 20px",
              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
              margin: "40px auto",
              maxWidth: "480px"
            }}>
              <div className="wf-loader-spinner" style={{
                position: "relative",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <div className="spinner-double-ring" style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  border: "4px solid transparent",
                  borderTopColor: "#0f766e",
                  borderBottomColor: "#0f766e",
                  borderRadius: "50%",
                  animation: "spin 1.5s linear infinite"
                }} />
                <div className="spinner-inner-ring" style={{
                  position: "absolute",
                  width: "70%",
                  height: "70%",
                  border: "3px solid transparent",
                  borderLeftColor: "#2563eb",
                  borderRightColor: "#2563eb",
                  borderRadius: "50%",
                  animation: "spin-reverse 1.2s linear infinite"
                }} />
                <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
              </div>
              
              <p style={{
                margin: "20px 0 6px 0",
                color: "#0f172a",
                fontSize: "15px",
                fontWeight: 800,
                letterSpacing: "-0.01em"
              }}>
                Fetching Onboarding Schema
              </p>
              <p style={{
                margin: 0,
                color: "#64748b",
                fontSize: "12.5px",
                fontWeight: 500,
                textAlign: "center"
              }}>
                Please wait while we retrieve the Recruiter onboarding form details.
              </p>
              
              <div style={{
                width: "120px",
                height: "3px",
                background: "#e2e8f0",
                borderRadius: "2px",
                marginTop: "16px",
                overflow: "hidden",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  height: "100%",
                  width: "40%",
                  background: "linear-gradient(90deg, #0f766e, #2563eb)",
                  borderRadius: "2px",
                  animation: "pulse-loader 1.5s infinite ease-in-out"
                }} />
              </div>

              <style dangerouslySetInnerHTML={{ __html: `
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                @keyframes spin-reverse {
                  0% { transform: rotate(360deg); }
                  100% { transform: rotate(0deg); }
                }
                @keyframes pulse-loader {
                  0% { left: -40%; }
                  50% { left: 100%; }
                  100% { left: -40%; }
                }
              `}} />
            </div>
          )
        );
      }
      if (formType === "candidate") {
        return (
          candidateWfForm ? (
            <div className="as-form-body">
              <div className="row p-3">
                <WorkflowElement
                  wfTask={candidateWfTask}
                  wfForm={candidateWfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={candidateUpdatedStateData}
                />
              </div>
            </div>
          ) : (
            <div className="wf-loading-container" style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "60px 20px",
              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
              margin: "40px auto",
              maxWidth: "480px"
            }}>
              <div className="wf-loader-spinner" style={{
                position: "relative",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <div className="spinner-double-ring" style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  border: "4px solid transparent",
                  borderTopColor: "#0f766e",
                  borderBottomColor: "#0f766e",
                  borderRadius: "50%",
                  animation: "spin 1.5s linear infinite"
                }} />
                <div className="spinner-inner-ring" style={{
                  position: "absolute",
                  width: "70%",
                  height: "70%",
                  border: "3px solid transparent",
                  borderLeftColor: "#2563eb",
                  borderRightColor: "#2563eb",
                  borderRadius: "50%",
                  animation: "spin-reverse 1.2s linear infinite"
                }} />
                <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
              </div>
              
              <p style={{
                margin: "20px 0 6px 0",
                color: "#0f172a",
                fontSize: "15px",
                fontWeight: 800,
                letterSpacing: "-0.01em"
              }}>
                Fetching Onboarding Schema
              </p>
              <p style={{
                margin: 0,
                color: "#64748b",
                fontSize: "12.5px",
                fontWeight: 500,
                textAlign: "center"
              }}>
                Please wait while we retrieve the Candidate onboarding form details.
              </p>
              
              <div style={{
                width: "120px",
                height: "3px",
                background: "#e2e8f0",
                borderRadius: "2px",
                marginTop: "16px",
                overflow: "hidden",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  height: "100%",
                  width: "40%",
                  background: "linear-gradient(90deg, #0f766e, #2563eb)",
                  borderRadius: "2px",
                  animation: "pulse-loader 1.5s infinite ease-in-out"
                }} />
              </div>

              <style dangerouslySetInnerHTML={{ __html: `
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                @keyframes spin-reverse {
                  0% { transform: rotate(360deg); }
                  100% { transform: rotate(0deg); }
                }
                @keyframes pulse-loader {
                  0% { left: -40%; }
                  50% { left: 100%; }
                  100% { left: -40%; }
                }
              `}} />
            </div>
          )
        );
      }
      return (
        <ViewCandidate
          viewShowHide={true}
          viewType={formType}
          selectedObj={formType === "candidate" ? (candidateObj || item) : item}
          filterSubcontractorList={[]}
          filterRecruiterList={[]}
          onClose={handleSummaryPopupHide}
          wfTask={summaryWorkflowTask}
          embedded={false}
          hideHeader={true}
        />
      );
    }

    return null;
  };

  const getSubcontractorPhone = () => {
    let val = getFieldData(
      candidateObj?.performerData,
      "subcontractorenrollmentform",
      "Company_Phone",
    );
    if (!val) {
      val = getFieldData(
        item?.performerData,
        "subcontractorenrollmentform",
        "Company_Phone",
      );
    }
    return val;
  };

  const getRecruiterPhone = () => {
    let val = getFieldData(
      candidateObj?.performerData,
      "recruiterenrollmentform",
      "Company_Phone",
    );
    if (!val) {
      val = getFieldData(
        item?.performerData,
        "recruiterenrollmentform",
        "Company_Phone",
      );
    }
    return val;
  };

  return (
    <React.Fragment>
      <style>{`
        @keyframes rtFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes rtSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .wf-icon-calendar-start {
          background: #ecfdf5 !important;
          color: #059669 !important;
        }

        .wf-icon-calendar-end {
          background: #fff1f2 !important;
          color: #e11d48 !important;
        }

        /* ── Partner Card (Subcontractor / Recruiter) ─── */
        .wf-partner-card {
          display: flex !important;
          align-items: flex-start !important;
          gap: 8px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-partner-column-stack {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          width: 100% !important;
        }

        .wf-partner-summary-card {
          padding: 10px !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          background: #ffffff !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-partner-left {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 4px !important;
          flex-shrink: 0 !important;
        }

        .wf-partner-avatar {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          background: linear-gradient(135deg, #ccfbf1 0%, #dbeafe 100%) !important;
          color: #0f766e !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          letter-spacing: 0.5px !important;
          flex: 0 0 auto !important;
          box-shadow: 0 3px 6px rgba(15, 118, 110, 0.08) !important;
          border: 2px solid #ffffff !important;
          outline: 1px solid #dbeafe !important;
        }

        .wf-partner-avatar.is-recruiter {
          background: linear-gradient(135deg, #ede9fe 0%, #e0f2fe 100%) !important;
          color: #6d28d9 !important;
          box-shadow: 0 3px 6px rgba(109, 40, 217, 0.08) !important;
          outline-color: #ddd6fe !important;
        }

        .wf-partner-avatar.is-candidate {
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
          color: #2563eb !important;
          box-shadow: 0 3px 6px rgba(37, 99, 235, 0.08) !important;
          outline-color: #bfdbfe !important;
        }

        .wf-partner-avatar.is-inactive {
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
          color: #64748b !important;
          box-shadow: 0 3px 6px rgba(100, 116, 139, 0.06) !important;
          outline-color: #cbd5e1 !important;
        }

        .wf-partner-avatar-id {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 9px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 20px !important;
          padding: 0px 6px !important;
          white-space: nowrap !important;
          letter-spacing: 0.2px !important;
        }

        .wf-agency-avatar {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          background: linear-gradient(135deg, #fef3c7 0%, #dbeafe 100%) !important;
          color: #b45309 !important;
          border: 2px solid #ffffff !important;
          outline: 1px solid #fde68a !important;
          box-shadow: 0 3px 6px rgba(180, 83, 9, 0.06) !important;
          flex: 0 0 auto !important;
          font-size: 12px !important;
        }

        .wf-metric-avatar {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          border: 2px solid #ffffff !important;
          flex: 0 0 auto !important;
          font-size: 12px !important;
        }

        .wf-metric-avatar.is-duration {
          background: linear-gradient(135deg, #e0f2fe 0%, #ede9fe 100%) !important;
          color: #0369a1 !important;
          outline: 1px solid #bae6fd !important;
          box-shadow: 0 3px 6px rgba(3, 105, 161, 0.06) !important;
        }

        .wf-metric-avatar.is-msp {
          background: linear-gradient(135deg, #fef3c7 0%, #ffedd5 100%) !important;
          color: #b45309 !important;
          outline: 1px solid #fde68a !important;
          box-shadow: 0 3px 6px rgba(180, 83, 9, 0.06) !important;
        }

        .wf-partner-body {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .wf-partner-name {
          font-size: 11px !important;
          font-weight: 800 !important;
          color: #0f172a !important;
          text-transform: uppercase !important;
          letter-spacing: 0.3px !important;
          line-height: 1.2 !important;
          word-break: break-word !important;
        }

        .wf-partner-name-row {
          display: flex !important;
          align-items: flex-start !important;
          gap: 6px !important;
          min-width: 0 !important;
        }

        .wf-partner-status-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 18px !important;
          height: 18px !important;
          border-radius: 999px !important;
          flex: 0 0 auto !important;
          font-size: 10px !important;
          margin-top: -1px !important;
        }

        .wf-partner-status-icon.is-active {
          background: #ecfdf5 !important;
          border: 1px solid #a7f3d0 !important;
          color: #047857 !important;
        }

        .wf-partner-status-icon.is-inactive {
          background: #fef2f2 !important;
          border: 1px solid #fecaca !important;
          color: #dc2626 !important;
        }

        .wf-partner-info-row {
          display: flex !important;
          align-items: flex-start !important;
          gap: 6px !important;
          font-size: 11px !important;
          color: #475569 !important;
          line-height: 1.35 !important;
          word-break: normal !important;
          overflow-wrap: anywhere !important;
        }

        .wf-partner-info-row i {
          font-size: 11px !important;
          flex-shrink: 0 !important;
        }

        .wf-entity-action-bar {
          background: #ffffff !important;
          border: 1px solid #eef2f6 !important;
          border-radius: 8px !important;
          padding: 6px 8px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          margin-top: 6px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-entity-action-bar-row {
          display: grid !important;
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 6px !important;
          width: 100% !important;
        }

        .wf-entity-action-bar .wf-tool-btn {
          width: 100% !important;
          justify-content: center !important;
          padding: 7px 8px !important;
          font-size: 11px !important;
          gap: 5px !important;
          box-sizing: border-box !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          white-space: nowrap !important;
        }

        .wf-entity-action-bar:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px) !important;
        }

        .wf-tool-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          border: 1px solid #dbe3ef !important;
          border-radius: 8px !important;
          background: #f8fafc !important;
          color: #334155 !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          padding: 7px 10px !important;
          transition: all 0.18s ease !important;
          cursor: pointer !important;
          white-space: nowrap !important;
        }

        .wf-tool-btn:hover {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
        }

        .wf-entity-badge-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 6px !important;
          margin-top: 4px !important;
        }

        .wf-entity-badge {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 3px 8px !important;
          border-radius: 6px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          border: 1px solid transparent !important;
        }

        .wf-entity-badge.basis-c2c {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1e40af !important;
        }

        .wf-entity-badge.basis-1099 {
          background: #faf5ff !important;
          border-color: #e9d5ff !important;
          color: #6b21a8 !important;
        }

        .wf-entity-badge.basis-w2 {
          background: #ecfdf5 !important;
          border-color: #a7f3d0 !important;
          color: #065f46 !important;
        }

        .rt-page {
          animation: rtFadeIn 0.28s ease both;
          --c-bg: #ffffff;
          --c-surface: #f8fafc;
          --c-canvas: #f3f6fb;
          --c-border: #e2e8f0;
          --c-border-light: #f1f5f9;
          --c-text: #0f172a;
          --c-text-2: #475569;
          --c-text-3: #94a3b8;

          --c-indigo: #2563eb;
          --c-indigo-h: #1d4ed8;
          --c-indigo-s: #eff6ff;
          --c-indigo-m: #bfdbfe;

          --c-green: #16a34a;
          --c-green-s: #f0fdf4;

          --c-amber: #d97706;
          --c-amber-s: #fffbeb;

          --c-rose: #e11d48;
          --c-rose-s: #fff1f2;

          --c-sky: #0284c7;
          --c-sky-s: #f0f9ff;

          --c-violet: #6d28d9;
          --c-violet-s: #f5f3ff;

          --r-sm: 6px;
          --r-md: 10px;
          --r-lg: 16px;
          --r-xl: 20px;

          --sh-sm: 0 1px 2px rgba(0,0,0,.05);
          --sh-md: 0 4px 12px rgba(0,0,0,.06);
          --sh-lg: 0 8px 24px rgba(0,0,0,.07);
        }
        .rt-shell {
          border: 1px solid rgba(226,232,240,0.88);
          border-radius: 18px;
          background: #ffffff;
          box-shadow: 0 18px 45px -28px rgba(15,23,42,0.35);
          overflow: hidden;
        }
        .rt-hero {
          display: grid;
          grid-template-columns: 1fr auto;
          align-items: stretch;
          gap: 20px;
          padding: 24px;
          background: linear-gradient(135deg, rgba(239,246,255,0.9) 0%, #ffffff 46%, #f8fafc 100%);
          border-bottom: 1px solid var(--c-border-light);
          position: relative;
          overflow: hidden;
        }
        .rt-hero::before {
          content: "";
          position: absolute;
          inset: 0 0 auto 0;
          height: 3px;
          background: linear-gradient(90deg, #2563eb, #10b981, #eab308);
        }
        .rt-hero-left {
          display: flex;
          gap: 16px;
          align-items: flex-start;
          min-width: 260px;
          flex: 1 1 360px;
          position: relative;
          z-index: 1;
        }
        .rt-hero-main {
          flex: 1;
          min-width: 0;
        }
        .rt-hero-icon {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1d4ed8;
          background: #ffffff;
          border: 1px solid #bfdbfe;
          font-size: 15px;
          font-weight: 900;
          letter-spacing: 0.03em;
          flex-shrink: 0;
          box-shadow: 0 10px 24px rgba(37,99,235,0.12);
          position: relative;
        }
        .rt-hero-icon-badge {
          position: absolute;
          right: -5px;
          bottom: -5px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #2563eb;
          color: #ffffff;
          border: 2px solid #ffffff;
          font-size: 9px;
          box-shadow: 0 4px 8px rgba(37,99,235,0.2);
        }
        .rt-kicker {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          margin: 0 0 8px;
          color: #1d4ed8;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          border-radius: 999px;
          padding: 4px 9px;
        }
        .rt-title {
          font-size: 20px;
          font-weight: 900;
          color: var(--c-text);
          margin: 0;
          line-height: 1.15;
          letter-spacing: 0;
        }
        .rt-subtitle {
          font-size: 11px !important;
          color: #64748b;
          margin: 7px 0 0;
          max-width: 620px;
          line-height: 1.45;
        }
        .rt-hero-highlights {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
          margin-top: 12px;
        }
        .rt-hero-highlight {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 7px 10px;
          border-radius: 8px;
          background: rgba(255,255,255,0.82);
          border: 1px solid #e2e8f0;
          color: #334155;
          font-size: 10px;
          font-weight: 800;
          box-shadow: 0 2px 6px rgba(15,23,42,0.03);
        }
        .rt-hero-highlight i {
          color: #2563eb;
          font-size: 11px;
        }
        .rt-meta {
          display: flex;
          align-items: center;
          gap: 7px;
          flex-wrap: wrap;
          margin-top: 12px;
        }
        .rt-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: 99px;
          font-size: 11px;
          font-weight: 700;
          white-space: nowrap;
          transition: all 0.15s ease;
          border: 1px solid var(--c-border);
          background: #ffffff;
          color: #475569;
        }
        .rt-pill i { font-size: 11px; }

        .rt-pill.meta-id i { color: #64748b; }
        .rt-pill.meta-ipcs i { color: var(--c-indigo); }
        .rt-pill.meta-person i { color: #16a34a; }
        .rt-pill.meta-email i { color: #0284c7; }
        .rt-pill.meta-phone i,
        .rt-pill.meta-users i { color: #7e22ce; }
        .rt-pill.meta-date i { color: #d97706; }
        .rt-pill.meta-workflow i { color: #6d28d9; }
        .rt-pill.meta-phase i { color: #db2777; }
        .rt-pill.meta-ciid i { color: #0d9488; }
        .rt-pill.success i { color: var(--c-green) !important; }
        .rt-pill.warning i { color: var(--c-amber) !important; }
        .rt-pill.danger i { color: var(--c-rose) !important; }

        .rt-summary-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding: 10px 16px;
          background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
          border-bottom: 1px solid var(--c-border-light);
          animation: rtSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          align-items: stretch;
        }
        .rt-summary-header {
          width: 100%;
          grid-column: 1 / -1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 0 2px 2px;
        }
        .rt-summary-title {
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 0;
          color: #0f172a;
          font-size: 12px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }
        .rt-summary-title i {
          width: 24px;
          height: 24px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #eff6ff;
          color: #2563eb;
          border: 1px solid #bfdbfe;
          font-size: 11px;
        }
        .rt-summary-context {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          max-width: 46%;
          color: #64748b;
          font-size: 10px;
          font-weight: 800;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .rt-stat-card.is-large-card {
          flex: 2 1 490px;
        }
        .rt-stat-card.is-small-card {
          flex: 1 1 285px;
        }
        .rt-stat-card.is-empty-card {
          flex: 0 0 150px !important;
          min-width: 150px !important;
        }
        .rt-stat-card {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          min-width: 0;
          height: auto;
          padding: 10px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          background: #ffffff;
          box-shadow: 0 2px 8px rgba(15,23,42,0.035);
          position: relative;
          overflow: hidden;
          transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
        }
        .rt-stat-card::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: #dbeafe;
        }
        .rt-stat-card:hover {
          border-color: #cbd5e1;
          box-shadow: 0 8px 20px rgba(15,23,42,0.06);
          transform: translateY(-1px);
        }
        .rt-stat-icon {
          width: 34px;
          height: 34px;
          width: 28px;
          height: 28px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 28px;
          background: var(--c-indigo-s);
          color: var(--c-indigo);
          font-size: 12px;
        }
        .rt-stat-icon.is-green { background: var(--c-green-s); color: var(--c-green); }
        .rt-stat-icon.is-amber { background: var(--c-amber-s); color: var(--c-amber); }
        .rt-stat-icon.is-rose { background: var(--c-rose-s); color: var(--c-rose); }
        .rt-stat-icon.is-sky { background: var(--c-sky-s); color: var(--c-sky); }
        .rt-stat-label {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #64748b;
          font-size: 9px;
          font-weight: 900;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 4px;
        }
        .rt-stat-value {
          display: block;
          color: var(--c-text);
          font-size: 11px !important;
          font-weight: 850;
          line-height: 1.25;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .wf-identity-meta-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          margin-top: 5px;
          color: #475569;
          font-size: 11px;
        }
        .wf-identity-meta-icon {
          width: 18px;
          height: 18px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 1px;
        }
        .wf-identity-meta-icon i {
          font-size: 10px !important;
          color: inherit !important;
        }
        .wf-icon-email {
          background: #eff6ff;
          color: #2563eb;
        }
        .wf-icon-phone {
          background: #fff7ed;
          color: #ea580c;
        }
        .wf-icon-calendar {
          background: #faf5ff;
          color: #7c3aed;
        }
        .wf-icon-address {
          background: #fff1f2;
          color: #e11d48;
        }
        .wf-icon-candidate {
          background: #eff6ff;
          color: #2563eb;
        }
        .wf-icon-building {
          background: #f0fdfa;
          color: #0f766e;
        }
        .wf-icon-recruiter {
          background: #f5f3ff;
          color: #7c3aed;
        }
        .wf-icon-percent {
          background: #fef3c7;
          color: #b45309;
        }
        .wf-icon-client {
          background: #eef2ff;
          color: #4f46e5;
        }
        .wf-icon-money {
          background: #f0fdf4;
          color: #16a34a;
        }
        .wf-identity-meta-text {
          flex: 1;
          min-width: 0;
          word-break: break-all;
          line-height: 1.4;
        }
        .wf-identity-address-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .rt-actions {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 12px;
          min-width: 320px;
          position: relative;
          z-index: 1;
        }
        .rt-action-buttons-group {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-end;
          padding: 8px;
          background: rgba(255,255,255,0.74);
          border: 1px solid rgba(226,232,240,0.92);
          border-radius: 10px;
          box-shadow: 0 8px 22px rgba(15,23,42,0.04);
        }
        .rt-app-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 10px 16px;
          background: rgba(241, 245, 249, 0.6);
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 12px;
          width: 100%;
          max-width: 650px;
          transition: all 0.2s ease-in-out;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
        }
        .rt-app-card:hover {
          background: rgba(241, 245, 249, 0.9);
          border-color: rgba(203, 213, 225, 0.9);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
        }
        .rt-app-card-left {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 0;
          flex: 1;
        }
        .rt-app-card-actions {
          display: grid;
          grid-template-columns: repeat(2, auto);
          gap: 8px;
          flex-shrink: 0;
          align-items: center;
        }
        .rt-app-card-icon {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
          box-shadow: 0 4px 8px rgba(37, 99, 235, 0.15);
        }
        .rt-app-card-info {
          display: flex;
          flex-direction: column;
          min-width: 0;
        }
        .rt-app-card-label {
          font-size: 9px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #64748b;
          margin-bottom: 2px;
        }
        .rt-app-card-title {
          font-size: 13px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 4px 0;
          word-break: break-word;
        }
        .rt-app-card-meta {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 11px;
        }
        .rt-app-card-ciid {
          color: #475569;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 3px;
        }
        .rt-app-card-status {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-weight: 700;
          padding: 2px 6px;
          border-radius: 6px;
        }
        .rt-app-card-status.is-complete {
          background: rgba(22, 163, 74, 0.1);
          color: #16a34a;
        }
        .rt-app-card-status.is-review {
          background: rgba(217, 119, 6, 0.1);
          color: #d97706;
        }
        .rt-quick-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }
        .rt-quick-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          padding: 7px 10px;
          border-radius: 8px;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #475569;
          font-size: 11px;
          font-weight: 800;
          transition: all 0.18s ease;
          cursor: pointer;
          white-space: nowrap;
        }
        .rt-quick-btn i { color: inherit; }
        .rt-quick-btn:hover {
          background: #eff6ff;
          color: #1d4ed8;
          border-color: #bfdbfe;
          transform: translateY(-1px);
        }
        .rt-quick-btn.active {
          color: #1d4ed8;
          background: rgba(37, 99, 235, 0.1);
          border-color: rgba(37, 99, 235, 0.2);
          font-weight: 800;
        }
        .rt-quick-btn.active i {
          color: #1d4ed8;
        }
        
        .rt-action-btn,
        .rt-page .btn-modern {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 5px !important;
          border-radius: 8px !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          color: #475569 !important;
          padding: 7px 10px !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: none !important;
        }
        .rt-action-btn:hover,
        .rt-page .btn-modern:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          text-decoration: none !important;
        }
        .rt-action-btn.primary,
        .rt-page .btn-modern-primary {
          background: #2563eb !important;
          border-color: #2563eb !important;
          color: #ffffff !important;
        }
        .rt-action-btn.primary:hover,
        .rt-page .btn-modern-primary:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }

        .rt-body {
          padding: 18px;
          background: #f8fafc;
        }
        .rt-panel {
          --task-accent: #64748b;
          --task-soft: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(15,23,42,0.04);
          overflow: hidden;
        }
        .rt-panel + .rt-panel { margin-top: 16px; }

        .rt-panel.btn-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
        .rt-panel.btn-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
        .rt-panel.btn-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
        .rt-panel.btn-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
        .rt-panel.btn-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
        .rt-panel.btn-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
        .rt-panel.btn-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
        .rt-panel.btn-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
        .rt-panel.btn-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
        .rt-panel.btn-default,
        .rt-panel.btn-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

        .rt-panel-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 14px 16px;
          background: linear-gradient(90deg, var(--task-soft), #ffffff 56%);
          border-bottom: 1px solid #edf2f7;
          border-left: 4px solid var(--task-accent);
        }
        .rt-panel-title {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          margin: 0;
          color: #0f172a;
          font-size: 15px;
          font-weight: 850;
          line-height: 1.25;
        }
        .rt-panel-title i {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: var(--task-accent);
          background: #ffffff;
          border: 1px solid var(--task-accent);
          box-shadow: 0 2px 8px rgba(15,23,42,0.05);
          font-size: 14px;
        }
        .rt-panel-title-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          padding: 5px 9px;
          border-radius: 999px;
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          background: var(--task-soft);
          color: var(--task-accent);
          border: 1px solid #e2e8f0;
          font-style: normal;
        }
        .rt-panel-header .rt-action-btn {
          min-height: auto !important;
          padding: 7px 10px !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          border-radius: 8px !important;
          gap: 5px !important;
          white-space: nowrap !important;
        }
        .rt-panel-body { padding: 14px 16px; }
        .rt-entity-panel { margin-bottom: 14px; }
        .rt-module-banner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          width: 100%;
          min-height: 40px;
          border-radius: 12px;
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          color: #1d4ed8;
          font-weight: 850;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }
        .rt-workflow-strip {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px 14px;
          margin-bottom: 14px;
          border: 1px solid #e2e8f0;
          border-radius: 13px;
          background: #ffffff;
        }
        .rt-workflow-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          border: 0;
          background: transparent;
          padding: 0;
          color: #2563eb;
          font-size: 13px;
          font-weight: 800;
          cursor: pointer;
        }
        .rt-workflow-link:hover { text-decoration: underline; }
        .rt-workbench-shell {
          position: relative;
          width: 100%;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          background: #ffffff;
          overflow: hidden;
          box-shadow: 0 12px 34px -28px rgba(15,23,42,0.5);
        }
        .rt-workbench-container {
          display: flex;
          width: 100%;
          min-height: 600px;
        }
        .rt-journey-side {
          width: 320px;
          min-width: 320px;
          border-right: 1px solid #e2e8f0;
          background: #fbfdff;
          display: flex;
          flex-direction: column;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .rt-workbench-shell.collapsed .rt-journey-side {
          width: 70px;
          min-width: 70px;
        }
        .rt-workbench-shell.collapsed .rt-task-header.workflow-phases {
          justify-content: center;
          padding-left: 0;
          padding-right: 0;
        }
        .rt-workbench-shell.collapsed .rt-task-header.workflow-phases .rt-task-title {
          display: none;
        }
        .rt-main-side {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
          background: #ffffff;
        }
        .rt-task-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 13px 15px;
          min-height: 56px;
          color: #1e293b;
          font-size: 13px;
          font-weight: 850;
          background: #ffffff;
          border-bottom: 2px solid #f1f5f9;
          border-left: 4px solid transparent;
        }
        
        /* Dynamic phase line on header only */
        .rt-task-header.btn-primary { border-left-color: #3b82f6 !important; }
        .rt-task-header.btn-info { border-left-color: #06b6d4 !important; }
        .rt-task-header.btn-warning { border-left-color: #f59e0b !important; }
        .rt-task-header.btn-success { border-left-color: #22c55e !important; }
        .rt-task-header.btn-wf2-default { border-left-color: #eab308 !important; }
        .rt-task-header.btn-wf3-default { border-left-color: #10b981 !important; }
        .rt-task-header.btn-wf4-default { border-left-color: #ef4444 !important; }
        .rt-task-header.btn-wf5-default { border-left-color: #f97316 !important; }
        .rt-task-header.btn-wf6-default { border-left-color: #8b5cf6 !important; }

        .rt-task-header.workflow-phases {
          background: #ffffff;
        }

        .rt-task-header .rt-task-title {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          white-space: nowrap;
          overflow: hidden;
          color: inherit;
        }

        .rt-task-header .rt-task-title-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 32px;
          width: 32px;
          height: 32px;
          border-radius: 10px;
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          font-size: 14px;
          color: #2563eb;
        }
        
        /* Match icon to phase color if header has phase class */
        .rt-task-header.btn-primary .rt-task-title-icon { background: #eff6ff; color: #3b82f6; border-color: #bfdbfe; }
        .rt-task-header.btn-info .rt-task-title-icon { background: #ecfeff; color: #06b6d4; border-color: #a5f3fc; }
        .rt-task-header.btn-warning .rt-task-title-icon { background: #fffbeb; color: #f59e0b; border-color: #fef3c7; }
        .rt-task-header.btn-success .rt-task-title-icon { background: #f0fdf4; color: #22c55e; border-color: #bbf7d0; }
        .rt-task-header.btn-wf2-default .rt-task-title-icon { background: #fef9c3; color: #eab308; border-color: #fef08a; }
        .rt-task-header.btn-wf3-default .rt-task-title-icon { background: #ecfdf5; color: #10b981; border-color: #a7f3d0; }
        .rt-task-header.btn-wf4-default .rt-task-title-icon { background: #fef2f2; color: #ef4444; border-color: #fca5a5; }
        .rt-task-header.btn-wf5-default .rt-task-title-icon { background: #fff7ed; color: #f97316; border-color: #ffedd5; }
        .rt-task-header.btn-wf6-default .rt-task-title-icon { background: #f5f3ff; color: #8b5cf6; border-color: #ddd6fe; }

        .rt-task-header .rt-task-info {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .rt-task-header .rt-task-phase-name {
          opacity: 0.8;
          font-weight: 700;
        }
        .rt-task-header .rt-task-separator {
          opacity: 0.3;
          font-weight: 400;
          margin: 0 2px;
        }
        .rt-task-header .rt-task-item-name {
          font-weight: 850;
        }

        .rt-header-actions {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .rt-refresh-link, .rt-toggle-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          color: #64748b;
          border-radius: 10px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .rt-refresh-link:hover, .rt-toggle-btn:hover {
          background: #f1f5f9;
          color: #1e293b;
          border-color: #cbd5e1;
        }
        .rt-journey-content {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }
        /* No horizontal padding here: the .col-md-12 inside contributes
           bootstrap's own 15px, which matches the journey sidebar's inset. */
        .rt-content-scroll {
          flex: 1;
          overflow-x: auto;
          padding: 20px 0;
          background: #f8fafc;
        }
        .rt-content-scroll > .row {
          min-width: 800px;
          margin: 0;
        }
        
        /* Fix text colors for specific phase classes if needed */
        .btn-default, .btn-wf-default { color: #334155 !important; }
        .btn-default .rt-task-title-icon, .btn-wf-default .rt-task-title-icon { color: #334155 !important; border-color: rgba(0,0,0,0.1) !important; background: rgba(0,0,0,0.05) !important; }
        .btn-default .rt-refresh-link, .btn-wf-default .rt-refresh-link,
        .btn-default .rt-toggle-btn, .btn-wf-default .rt-toggle-btn { color: #334155 !important; border-color: rgba(0,0,0,0.1) !important; background: rgba(0,0,0,0.05) !important; }

        @media (max-width: 1024px) {
          .rt-workbench-container { flex-direction: column; }
          .rt-journey-side { width: 100% !important; min-width: 100% !important; border-right: 0; border-bottom: 1px solid #e2e8f0; }
          .rt-workbench-shell.collapsed .rt-journey-side { height: 56px; overflow: hidden; }
        }

        .rt-phase-toggle:hover {
          background: #2563eb;
          color: #ffffff;
          transform: translateX(-1px);
        }
        .rt-workbench-shell.collapsed .rt-phase-toggle {
          left: 12px;
        }
        .rt-workbench-shell.collapsed .rt-phase-toggle:hover {
          transform: translateX(1px);
        }
        /* These chips act as tabs, so they read as one segmented control.
           A lone chip in the group renders as a single-tab track, which keeps
           the Reporting "Documents" toggle consistent with the others. */
        .rt-component-actions {
          display: flex;
          width: fit-content;
          flex-wrap: wrap;
          gap: 4px;
          margin-bottom: 14px;
          padding: 4px;
          max-width: 100%;
          background: #f1f5f9;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
        }
        .rt-page .rt-chip-btn {
          border-radius: 8px !important;
          padding: 7px 10px !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          color: #475569 !important;
        }
        .rt-page .rt-chip-btn.active {
          background: #eff6ff !important;
          border-color: #93c5fd !important;
          color: #1d4ed8 !important;
        }
        .rt-page .rt-component-actions .rt-chip-btn {
          border-radius: 9px !important;
          padding: 7px 13px !important;
          font-size: 11.5px !important;
          font-weight: 700 !important;
          border-color: transparent !important;
          background: transparent !important;
          color: #64748b !important;
          box-shadow: none !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .rt-page .rt-component-actions .rt-chip-btn:hover {
          background: rgba(255, 255, 255, 0.7) !important;
          color: #0f172a !important;
        }
        .rt-page .rt-component-actions .rt-chip-btn.active {
          background: #ffffff !important;
          border-color: #e2e8f0 !important;
          color: #1d4ed8 !important;
          font-weight: 800 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 5px -2px rgba(15, 23, 42, 0.08) !important;
        }
        .rt-page .rt-component-actions .rt-chip-btn i {
          opacity: 0.75;
        }
        .rt-page .rt-component-actions .rt-chip-btn.active i {
          opacity: 1;
        }
        .rt-tool-close {
          display: flex;
          justify-content: flex-end;
          margin: 10px 0;
        }

        @media (max-width: 1024px) {
          .rt-hero { display: flex; flex-direction: column; gap: 16px; }
          .rt-actions { justify-content: flex-start; align-items: flex-start; width: 100%; min-width: 0; }
          .rt-action-buttons-group {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: flex-start;
            width: 100%;
          }
          .rt-body { padding: 12px; }
          .rt-summary-grid {
            padding-left: 16px;
            padding-right: 16px;
          }
          .rt-journey-cell,
          .rt-content-cell {
            display: block;
            width: 100% !important;
            min-width: 0;
            border-right: 0 !important;
          }
          .rt-journey-head {
            width: 100%;
          }
          .rt-phase-toggle {
            top: 50px;
            left: auto !important;
            right: 12px;
          }
          .rt-content-scroll > .row {
            min-width: 640px;
          }
        }

        @media (max-width: 768px) {
          .rt-summary-grid {
            flex-direction: column;
          }
          .rt-stat-card.is-large-card,
          .rt-stat-card.is-small-card,
          .rt-stat-card.is-empty-card {
            width: 100% !important;
            flex: 1 1 auto !important;
          }
          .rt-summary-header {
            align-items: flex-start;
            flex-direction: column;
          }
          .rt-summary-context {
            max-width: 100%;
          }
          .rt-app-card {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
          }
          .rt-app-card-actions {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 8px;
            width: 100%;
          }
          .rt-app-card-actions .rt-quick-btn {
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 520px) {
          .rt-title {
            font-size: 1.1rem;
          }
          .rt-app-card-actions {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        /* ─── Review Tools Grid ──── */
        .rt-tools-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
          gap: 10px;
          margin-bottom: 16px;
        }

        .rt-tool-card {
          display: flex;
          align-items: center;
          gap: 11px;
          width: 100%;
          min-height: 58px;
          padding: 10px 12px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1), padding-left 0.2s ease, border-left 0.2s ease;
          position: relative;
          box-shadow: 0 1px 2px rgba(15,23,42,0.03);
          user-select: none;
          text-align: left;
          appearance: none;
        }

        .rt-tool-card:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          box-shadow: 0 4px 10px rgba(15, 23, 42, 0.05);
          transform: translateY(-1px);
        }

        .rt-tool-card:focus {
          outline: none;
        }

        .rt-tool-card:focus-visible {
          border-color: #2563eb;
          box-shadow: 0 0 0 3px #dbeafe;
        }

        .rt-tool-card.active {
          background: #ffffff;
          border-color: #2563eb;
          border-left: 4px solid #2563eb;
          padding-left: 9px;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
        }

        .rt-tool-card-icon-box {
          width: 36px;
          height: 36px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        /* Accent Themes for Icons */
        .rt-tool-card[data-theme="messages"] .rt-tool-card-icon-box { background: #eff6ff; color: #2563eb; }
        .rt-tool-card[data-theme="phone"] .rt-tool-card-icon-box { background: #fff7ed; color: #ea580c; }
        .rt-tool-card[data-theme="schedule"] .rt-tool-card-icon-box { background: #f0fdf4; color: #16a34a; }
        .rt-tool-card[data-theme="forms"] .rt-tool-card-icon-box { background: #faf5ff; color: #7c3aed; }
        .rt-tool-card[data-theme="templates"] .rt-tool-card-icon-box { background: #f5f3ff; color: #6d28d9; }
        .rt-tool-card[data-theme="reports"] .rt-tool-card-icon-box { background: #fff1f2; color: #e11d48; }
        .rt-tool-card[data-theme="default"] .rt-tool-card-icon-box { background: #f1f5f9; color: #475569; }

        .rt-tool-card.active .rt-tool-card-icon-box {
          background: #2563eb;
          color: #ffffff;
        }

        .rt-tool-card-info {
          flex: 1;
          min-width: 0;
        }

        .rt-tool-card-name {
          font-size: 12px;
          font-weight: 800;
          color: #1e293b;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.2;
        }

        .rt-tool-card.active .rt-tool-card-name {
          color: #1e40af;
        }

        .rt-tool-card-meta {
          display: block;
          margin-top: 3px;
          color: #64748b;
          font-size: 10px;
          font-weight: 750;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .rt-tool-card-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: 800;
          padding: 2px 6px;
          border-radius: 12px;
          min-width: 18px;
          height: 18px;
          flex-shrink: 0;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
        }

        .rt-tool-card-badge.is-unread {
          background: #fecaca;
          color: #dc2626;
        }

        .rt-tool-card-badge.is-read {
          background: #d1fae5;
          color: #065f46;
        }

        .rt-tool-card-arrow {
          color: #cbd5e1;
          font-size: 14px;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .rt-tool-card:hover .rt-tool-card-arrow,
        .rt-tool-card.active .rt-tool-card-arrow {
          color: #2563eb;
          transform: translateX(2px);
        }

        .rt-tools-empty {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 18px;
          margin-bottom: 16px;
          background: #f8fafc;
          border: 1px dashed #cbd5e1;
          border-radius: 10px;
        }

        .rt-tools-empty-icon {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          color: #64748b;
          border: 1px solid #e2e8f0;
          flex-shrink: 0;
        }

        .rt-tools-empty-title {
          margin: 0 0 3px 0;
          color: #334155;
          font-size: 13px;
          font-weight: 800;
        }

        .rt-tools-empty-desc {
          margin: 0;
          color: #64748b;
          font-size: 11px;
          line-height: 1.35;
        }

        /* ─── Task Info Card ──── */
        .rt-task-info-card {
          --task-accent: #64748b;
          --task-soft: #f8fafc;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 0;
          margin-bottom: 16px;
          box-shadow: 0 4px 14px rgba(15,23,42,0.04);
          overflow: hidden;
        }

        .rt-task-info-card.btn-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
        .rt-task-info-card.btn-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
        .rt-task-info-card.btn-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
        .rt-task-info-card.btn-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
        .rt-task-info-card.btn-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
        .rt-task-info-card.btn-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
        .rt-task-info-card.btn-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
        .rt-task-info-card.btn-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
        .rt-task-info-card.btn-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
        .rt-task-info-card.btn-default,
        .rt-task-info-card.btn-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

        .rt-task-info-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 14px 16px;
          background: linear-gradient(90deg, var(--task-soft), #ffffff 56%);
          border-bottom: 1px solid #edf2f7;
          border-left: 4px solid var(--task-accent);
        }

        .rt-task-info-heading {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 0;
        }

        .rt-task-info-icon {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: var(--task-accent);
          background: #ffffff;
          border: 1px solid var(--task-accent);
          box-shadow: 0 2px 8px rgba(15,23,42,0.05);
        }

        .rt-task-info-title-wrap {
          min-width: 0;
        }

        .rt-task-info-kicker {
          display: flex;
          align-items: center;
          gap: 7px;
          color: #64748b;
          font-size: 10px;
          font-weight: 850;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          line-height: 1.2;
        }

        .rt-task-info-dot {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: var(--task-accent);
          flex-shrink: 0;
        }

        .rt-task-info-title {
          margin: 3px 0 0 0;
          color: #0f172a;
          font-size: 15px;
          font-weight: 850;
          line-height: 1.25;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .rt-task-info-body {
          display: grid;
          grid-template-columns: minmax(0, 1fr) auto;
          gap: 16px;
          align-items: center;
          padding: 14px 16px;
        }

        .rt-task-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 10px;
          align-items: center;
        }

        .rt-task-info-item {
          display: flex;
          flex-direction: column;
          gap: 5px;
          min-width: 0;
          padding: 10px 12px;
          background: #f8fafc;
          border: 1px solid #edf2f7;
          border-radius: 8px;
        }

        .rt-task-info-label {
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #64748b;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }

        .rt-task-info-label i {
          font-size: 11px;
          color: var(--task-accent);
        }

        .rt-task-info-val {
          font-size: 12px;
          font-weight: 750;
          color: #1e293b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .rt-task-muted {
          color: #94a3b8;
          font-style: italic;
          font-weight: 650;
        }

        .rt-task-assignee {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
        }

        .rt-task-assignee-avatar {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: var(--task-soft);
          color: var(--task-accent);
          border: 1px solid #e2e8f0;
          font-size: 10px;
          font-weight: 850;
        }

        .rt-task-info-actions {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 7px;
          min-width: 0;
        }

        .rt-task-info-actions-label {
          color: #64748b;
          font-size: 10px;
          font-weight: 850;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .rt-task-info-action-list {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          flex-wrap: wrap;
        }

        .rt-task-info-action-list .rt-action-btn {
          min-height: auto !important;
          padding: 7px 10px !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          border-radius: 8px !important;
          gap: 5px !important;
          white-space: nowrap !important;
        }

        .rt-task-status-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          padding: 5px 9px;
          border-radius: 999px;
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          border: 1px solid transparent;
          white-space: nowrap;
        }

        .rt-task-status-badge.btn-primary,
        .rt-task-status-badge.btn-info,
        .rt-task-status-badge.btn-warning,
        .rt-task-status-badge.btn-success,
        .rt-task-status-badge.btn-wf2-default,
        .rt-task-status-badge.btn-wf3-default,
        .rt-task-status-badge.btn-wf4-default,
        .rt-task-status-badge.btn-wf5-default,
        .rt-task-status-badge.btn-wf6-default,
        .rt-task-status-badge.btn-default,
        .rt-task-status-badge.btn-wf-default {
          background: var(--task-soft);
          color: var(--task-accent);
          border-color: #e2e8f0;
        }

        .rt-task-status-badge.is-done {
          background: #d1fae5;
          color: #065f46;
        }

        @media (max-width: 1200px) {
          .rt-task-info-body {
            grid-template-columns: 1fr;
          }

          .rt-task-info-actions {
            align-items: flex-start;
          }

          .rt-task-info-action-list {
            justify-content: flex-start;
          }
        }

        @media (max-width: 900px) {
          .rt-task-info-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 640px) {
          .rt-task-info-top {
            align-items: flex-start;
            flex-direction: column;
          }

          .rt-task-info-grid {
            grid-template-columns: 1fr;
          }

          .rt-task-info-title {
            white-space: normal;
          }
        }

        /* Right Side Skeleton Loading */
        @keyframes rt-skeleton-pulse {
          0% { background-color: #f1f5f9; }
          50% { background-color: #cbd5e1; }
          100% { background-color: #f1f5f9; }
        }

        .rt-right-skeleton-pulse {
          animation: rt-skeleton-pulse 1.8s infinite ease-in-out;
        }

        .rt-right-skeleton-container {
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding: 24px;
          width: 100%;
        }

        .rt-right-skeleton-header {
          display: flex;
          align-items: center;
          gap: 16px;
          height: 60px;
          border-radius: 12px;
          background: #ffffff;
          border: 2px solid #e2e8f0;
          padding: 12px;
        }

        .rt-right-skeleton-icon {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          flex-shrink: 0;
        }

        .rt-right-skeleton-title {
          height: 16px;
          width: 250px;
          border-radius: 4px;
        }

        .rt-right-skeleton-body {
          display: flex;
          flex-direction: column;
          gap: 16px;
          background: #ffffff;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
        }

        .rt-right-skeleton-row {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .rt-right-skeleton-label {
          height: 12px;
          width: 120px;
          border-radius: 3px;
        }

        .rt-right-skeleton-field {
          height: 38px;
          width: 100%;
          border-radius: 6px;
        }

        /* Right Side Empty State Styles */
        .rt-right-empty-state {
          text-align: center;
          border: 2px dashed #e2e8f0;
          border-radius: 16px;
          padding: 48px 32px;
          background: #f8fafc;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: calc(100% - 48px);
          margin: 24px;
        }

        .rt-right-empty-icon {
          color: #94a3b8;
          margin-bottom: 16px;
        }

        .rt-right-empty-title {
          font-size: 15px;
          font-weight: 700;
          color: #475569;
          margin: 0 0 8px 0;
        }

        .rt-right-empty-desc {
          font-size: 12.5px;
          color: #64748b;
          margin: 0;
          line-height: 1.5;
          max-width: 320px;
        }

        /* Header Skeleton Loading */
        .rt-header-skeleton-kicker {
          height: 12px;
          width: 100px;
          border-radius: 3px;
          margin-bottom: 8px;
        }

        .rt-header-skeleton-title {
          height: 24px;
          width: 320px;
          border-radius: 6px;
          margin-bottom: 8px;
        }

        .rt-header-skeleton-subtitle {
          height: 14px;
          width: 450px;
          border-radius: 4px;
          margin-bottom: 12px;
        }

        .rt-header-skeleton-meta {
          display: flex;
          gap: 8px;
        }

        .rt-header-skeleton-pill {
          height: 26px;
          width: 120px;
          border-radius: 99px;
        }

        /* Ensure the modal and backdrop are on top of the sidebar (1050) and header (1060) */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .rt-summary-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .rt-summary-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .rt-summary-modal {
          --task-accent: #64748b;
          --task-soft: #f8fafc;
          max-width: 90% !important;
          width: 1200px !important;
        }
        .rt-summary-modal.theme-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
        .rt-summary-modal.theme-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
        .rt-summary-modal.theme-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
        .rt-summary-modal.theme-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
        .rt-summary-modal.theme-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
        .rt-summary-modal.theme-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
        .rt-summary-modal.theme-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
        .rt-summary-modal.theme-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
        .rt-summary-modal.theme-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
        .rt-summary-modal.theme-default,
        .rt-summary-modal.theme-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

        .rt-summary-modal .modal-content {
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          display: flex !important;
          flex-direction: column !important;
          max-height: calc(100vh - 40px) !important;
        }
        .rt-summary-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
          align-items: center;
        }
        .rt-summary-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }
        .rt-summary-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 14px !important;
          width: 100% !important;
        }
        .rt-summary-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }
        .rt-summary-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-summary-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }
        .rt-summary-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-summary-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .rt-summary-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-summary-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }
        .rt-summary-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 12px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          color: #64748b !important;
        }
        .rt-summary-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
        }
        .rt-summary-modal .rt-meta-chip i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }
        .rt-summary-modal .rt-meta-divider {
          width: 1px !important;
          height: 16px !important;
          background: #cbd5e1 !important;
          margin: 0 4px !important;
        }
        .rt-summary-modal .rt-meta-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 13px !important;
        }
        .rt-summary-modal .rt-meta-desc i {
          color: var(--task-accent) !important;
        }
        .rt-summary-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .rt-summary-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-summary-modal .wf-modal-footer-close-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }
        .rt-summary-modal .wf-modal-footer-close-btn:hover i {
          color: #ef4444 !important;
        }
        .rt-summary-modal .modal-body {
          background: #ffffff !important;
          padding: 24px !important;
          flex: 1 1 auto !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          min-height: 0 !important;
        }
        .rt-summary-modal .modal-body::-webkit-scrollbar {
          width: 6px !important;
          height: 6px !important;
        }
        .rt-summary-modal .modal-body::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .rt-summary-modal .modal-body::-webkit-scrollbar-thumb {
          background: #cbd5e1 !important;
          border-radius: 4px !important;
        }
        .rt-summary-modal .modal-body::-webkit-scrollbar-thumb:hover {
          background: #94a3b8 !important;
        }

        /* Premium Modal Footer Close Button */
        .rt-summary-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
        }

        /* Premium Header Close Button */
        .rt-summary-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .rt-summary-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-summary-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .rt-summary-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .rt-summary-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        .rt-summary-popup-body .rt-panel,
        .rt-summary-popup-body .aed-container,
        .rt-summary-popup-body .aer-container {
          margin-bottom: 0 !important;
        }

        /* ── Popup body scroll containment for form popups ── */
        .rt-summary-modal.modal-dialog-centered {
          min-height: calc(100vh - 40px) !important;
          max-height: calc(100vh - 40px) !important;
          margin-top: 20px !important;
          margin-bottom: 20px !important;
          display: flex !important;
          align-items: center !important;
        }
        .rt-summary-modal .modal-header {
          flex-shrink: 0 !important;
        }
        .rt-summary-modal .modal-footer {
          flex-shrink: 0 !important;
        }
        .rt-summary-popup-body {
          overflow: visible !important;
        }
        .rt-summary-popup-body .as-card {
          overflow: visible !important;
          box-shadow: none !important;
          border: none !important;
          margin-top: 0 !important;
          border-radius: 0 !important;
        }
        .rt-summary-popup-body .as-form-body {
          padding: 24px !important;
            background: #f8fafc !important;
            border-bottom: 1.5px solid #f1f5f9 !important;
        }
        .rt-summary-popup-body .as-form-footer {
          display: none !important;
        }
      `}</style>

      <Modal
        show={summaryPopupShowHide}
        onHide={handleSummaryPopupHide}
        size="xl"
        dialogClassName={`rt-summary-modal ${summaryThemeClass}`}
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i
                  className={`rt-header-icon fa ${getSummaryPopupIcon(summaryPopupType)}`}
                  aria-hidden="true"
                />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{getSummaryPopupTitle(summaryPopupType)}</span>
                      {wfTask?.wfPhase && (
                        <span className="rt-modal-title-badge">
                          {wfTask.wfPhase}
                        </span>
                      )}
                    </span>
                  </h2>
                  {(summaryHeaderName ||
                    summaryHeaderEmail ||
                    summaryHeaderPhone ||
                    summaryPopupDescription) && (
                      <div className="rt-modal-meta-row">
                        {summaryHeaderName && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-user" aria-hidden="true" />{" "}
                            {summaryHeaderName}
                          </span>
                        )}
                        {summaryHeaderEmail && (
                          <span
                            className="rt-meta-chip"
                            title={summaryHeaderEmail}
                          >
                            <i className="fa fa-envelope" aria-hidden="true" />{" "}
                            {summaryHeaderEmail}
                          </span>
                        )}
                        {summaryHeaderPhone && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-phone" aria-hidden="true" />{" "}
                            {formatUSPhoneNumber(summaryHeaderPhone)}
                          </span>
                        )}
                        {(summaryHeaderName ||
                          summaryHeaderEmail ||
                          summaryHeaderPhone) &&
                          summaryPopupDescription && (
                            <span className="rt-meta-divider" />
                          )}
                        {summaryPopupDescription && (
                          <span className="rt-meta-desc">
                            <i className="fa fa-info-circle" aria-hidden="true" />{" "}
                            {summaryPopupDescription}
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </div>

              <button
                type="button"
                className="rt-action-btn"
                onClick={handleSummaryPopupHide}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="rt-summary-popup-body">
            {renderSummaryPopupContent()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleSummaryPopupHide}
          >
            <i className="fa fa-times" aria-hidden="true" /> Close
          </button>
        </Modal.Footer>
      </Modal>

      <div className="rt-page">
        <div className="rt-shell">
          <div className="rt-hero">
            <div className="rt-hero-left">
              <div className="rt-hero-icon">
                {app ? (
                  heroInitials
                ) : (
                  <i className="fa fa-tasks" aria-hidden="true" />
                )}
                <span className="rt-hero-icon-badge">
                  <i className="fa fa-tasks" aria-hidden="true" />
                </span>
              </div>
              <div className="rt-hero-main">
                {!app ? (
                  <>
                    <div className="rt-header-skeleton-kicker rt-right-skeleton-pulse" />
                    <div className="rt-header-skeleton-title rt-right-skeleton-pulse" />
                    <div className="rt-header-skeleton-subtitle rt-right-skeleton-pulse" />
                    <div className="rt-header-skeleton-meta">
                      <div
                        className="rt-header-skeleton-pill rt-right-skeleton-pulse"
                        style={{ width: "80px" }}
                      />
                      <div
                        className="rt-header-skeleton-pill rt-right-skeleton-pulse"
                        style={{ width: "150px" }}
                      />
                      <div
                        className="rt-header-skeleton-pill rt-right-skeleton-pulse"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <p className="rt-kicker">
                      <i className="fa fa-briefcase" aria-hidden="true" />
                      {heroRecordType} Review
                    </p>
                    <p className="rt-title">{reviewTitle}</p>
                    <p className="rt-subtitle">
                      Review and manage onboarding workflow tasks for{" "}
                      {reviewSubject}.
                    </p>

                    <div className="rt-meta">
                      {appType !== "partner" ? (
                        <>
                          <span className="rt-pill meta-id">
                            <i className="fa fa-id-badge" aria-hidden="true" />
                            ID: #{item?.performerid || "N/A"}
                          </span>
                          {item?.maxloans && (
                            <span className="rt-pill meta-ipcs">
                              <i className="fa fa-hashtag" aria-hidden="true" />
                              IPCS ID: {item.maxloans}
                            </span>
                          )}
                          {reviewSubject && (
                            <span className="rt-pill meta-person">
                              <i className="fa fa-user" aria-hidden="true" />
                              {reviewSubject}
                            </span>
                          )}

                          <span className={`rt-pill ${candidateStatusClass}`}>
                            <i
                              className={`fa ${item?.isActive === true ? "fa-check" : item?.isActive === false ? "fa-times" : "fa-clock-o"}`}
                              aria-hidden="true"
                            />
                            Status: {candidateActiveStatus}
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="rt-pill meta-id">
                            <i className="fa fa-id-badge" aria-hidden="true" />
                            ID: #{item?.performerid || item?.fuid || "N/A"}
                          </span>
                          {item !== "" && (
                            <span className="rt-pill meta-person">
                              <i className="fa fa-user" aria-hidden="true" />
                              {reviewSubject}
                            </span>
                          )}
                          {(item?.email || item?.contact1?.performeremail) && (
                            <span className="rt-pill meta-email">
                              <i
                                className="fa fa-envelope-o"
                                aria-hidden="true"
                              />
                              {item?.email || item?.contact1?.performeremail}
                            </span>
                          )}
                          <span className={`rt-pill ${partnerStatusClass}`}>
                            <i
                              className={`fa ${item?.contact1?.isActive === true ? "fa-check" : item?.contact1?.isActive === false ? "fa-times" : "fa-clock-o"}`}
                              aria-hidden="true"
                            />
                            Status: {partnerContactStatus}
                          </span>
                          {type === "partner" && (
                            <span className="rt-pill meta-users">
                              <i className="fa fa-users" aria-hidden="true" />
                              {item?.activeUsers || 0} Active Users
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="rt-actions">
              {displayCiid !== "N/A" && (
                <div className="rt-app-card">
                  <div className="rt-app-card-left">
                    <div className="rt-app-card-icon">
                      <i className="fa fa-file-text-o" aria-hidden="true" />
                    </div>
                    <div className="rt-app-card-info">
                      <h4 className="rt-app-card-title">{displayAppName}</h4>
                      <div className="rt-app-card-meta">
                        <span className="rt-app-card-ciid">
                          <i className="fa fa-hashtag" aria-hidden="true" />{" "}
                          CIID: {displayCiid}
                        </span>
                        <span
                          className={`rt-app-card-status ${isAppSubmitted ? "is-complete" : "is-review"}`}
                        >
                          <i
                            className={`fa ${isAppSubmitted ? "fa-check-circle" : "fa-clock-o"}`}
                            aria-hidden="true"
                          />
                          {onboardingStatus}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="rt-app-card-actions">
                    {appType === "partner" && (
                      <>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && summaryPopupType?.startsWith("doc_") ? "active" : ""}`}
                          onClick={() => {
                            handleSummaryPopupShow(
                              resolvedUserType === "Recruiter"
                                ? "doc_recruiter"
                                : "doc_subcontractor",
                            );
                          }}
                        >
                          <i className="fa fa-file-text-o" aria-hidden="true" />
                          Documents
                        </button>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && ["form_subcontractor", "form_recruiter"].includes(summaryPopupType) ? "active" : ""}`}
                          onClick={() => {
                            const targetForm =
                              resolvedUserType === "Recruiter"
                                ? "form_recruiter"
                                : "form_subcontractor";
                            handleSummaryPopupShow(targetForm);
                          }}
                          title={`${resolvedUserType} Onboarding Form`}
                        >
                          <i className="fa fa-list-alt" aria-hidden="true" />
                          Onboarding Form
                        </button>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && summaryPopupType === "ach" ? "active" : ""}`}
                          onClick={() => {
                            handleSummaryPopupShow("ach");
                          }}
                        >
                          <i className="fa fa-credit-card" aria-hidden="true" />
                          ACH
                        </button>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && summaryPopupType === "insurance" ? "active" : ""}`}
                          onClick={() => {
                            handleSummaryPopupShow("insurance");
                          }}
                        >
                          <i className="fa fa-shield" aria-hidden="true" />
                          Insurance
                        </button>
                      </>
                    )}
                    {appType !== "partner" && (
                      <>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && summaryPopupType === "doc_candidate" ? "active" : ""}`}
                          onClick={() => {
                            handleSummaryPopupShow("doc_candidate");
                          }}
                          title="View Candidate Documents"
                        >
                          <i className="fa fa-file-text-o" aria-hidden="true" />
                          Documents
                        </button>
                        <button
                          type="button"
                          className={`rt-quick-btn ${summaryPopupShowHide && summaryPopupType === "form_candidate" ? "active" : ""}`}
                          onClick={() => {
                            handleSummaryPopupShow("form_candidate");
                          }}
                          title="Candidate Onboarding Form"
                        >
                          <i className="fa fa-list-alt" aria-hidden="true" />
                          Onboarding Form
                        </button>
                        {["W2 Basis", "1099 Basis"].includes(
                          getOnboardingField("CandidateEntity"),
                        ) && (
                            <button
                              type="button"
                              className={`rt-quick-btn ${toolShowHide && toolObj?.id === 42 ? "active" : ""}`}
                              onClick={() => {
                                handleSummaryPopupShow("ach");
                              }}
                              title="ACH Information"
                            >
                              <i className="fa fa-bank" aria-hidden="true" />
                              ACH
                            </button>
                          )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="rt-body">
            {/* ═══ SUMMARY DETAILS GRID ═══ */}
            {item !== "" && (
              <div className="row">
                <div className="col-md-12 form-group">
                  <div className={`rt-panel ${phaseClass}`}>
                    <div className="rt-panel-header">
                      <h2 className="rt-panel-title">
                        <i className="fa fa-id-card-o" aria-hidden="true" />
                        Summary Details
                        <span className="rt-panel-title-badge">
                          {reviewSubject}
                        </span>
                      </h2>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <button
                          type="button"
                          className="rt-action-btn"
                          onClick={handleBackToList}
                          style={{
                            color: "#2563eb",
                            borderColor: "rgba(37, 99, 235, 0.2)",
                          }}
                        >
                          <i className="fa fa-arrow-left" aria-hidden="true" />
                          Back
                        </button>
                        <button
                          type="button"
                          className="rt-action-btn"
                          onClick={() => setShowSummaryGrid(!showSummaryGrid)}
                          title={
                            showSummaryGrid
                              ? `Hide ${resolvedUserType} Details`
                              : `Show ${resolvedUserType} Details`
                          }
                        >
                          <i
                            className={`fa ${showSummaryGrid ? "fa-eye-slash" : "fa-eye"}`}
                            aria-hidden="true"
                          />
                          {showSummaryGrid ? "Hide Details" : "Show Details"}
                        </button>
                      </div>
                    </div>

                    {showSummaryGrid && (
                      <div
                        className="rt-panel-body"
                        style={{
                          background:
                            "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                          padding: "12px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            width: "100%",
                            alignItems: "stretch",
                          }}
                        >
                          {appType === "partner" ? (
                            <>
                              {/* Card 1: Subcontractor or Recruiter Card */}
                              <div className="rt-stat-card is-large-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    {resolvedUserType}
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <div
                                        className="wf-partner-left"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <div
                                          className={`wf-partner-avatar ${module === "Recruiter" ? "is-recruiter" : ""}`}
                                        >
                                          {(reviewSubject || "")
                                            .split(" ")
                                            .filter(Boolean)
                                            .slice(0, 2)
                                            .map((w) => w[0])
                                            .join("")
                                            .toUpperCase() || "PT"}
                                        </div>
                                        {(item?.performerid || item?.fuid) && (
                                          <span className="wf-partner-avatar-id">
                                            #{item?.performerid || item?.fuid}
                                          </span>
                                        )}
                                      </div>
                                      <div
                                        className="wf-partner-body"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        <span
                                          className="rt-stat-value"
                                          title={reviewSubject}
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "800",
                                            color: "#0f172a",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {reviewSubject}
                                        </span>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {(item?.email ||
                                            item?.companyEmail) && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-email"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#eff6ff",
                                                    color: "#2563eb",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-envelope-o" />
                                                </div>
                                                <span
                                                  style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {item?.email ||
                                                    item?.companyEmail}
                                                </span>
                                              </div>
                                            )}
                                          {(item?.contactNo ||
                                            item?.companyPhone) && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-phone"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fff7ed",
                                                    color: "#ea580c",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-phone" />
                                                </div>
                                                <span>
                                                  {getFormatedNumber(
                                                    item?.contactNo ||
                                                    item?.companyPhone,
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                          {item?.createdDate && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-calendar"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#fef2f2",
                                                  color: "#ef4444",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-calendar-o" />
                                              </div>
                                              <span>
                                                Joined:{" "}
                                                <Moment format="MMM D, YYYY">
                                                  {item.createdDate}
                                                </Moment>
                                              </span>
                                            </div>
                                          )}
                                          {(() => {
                                            const firstLine =
                                              item?.accessKey || "";
                                            const secondLine = [
                                              item?.portalUrl,
                                              item?.city,
                                              item?.state,
                                              item?.zip,
                                            ]
                                              .filter(Boolean)
                                              .join(", ");
                                            if (!firstLine && !secondLine)
                                              return null;
                                            return (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                  marginTop: "3px",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-address"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#f0fdf4",
                                                    color: "#16a34a",
                                                    fontSize: "9px",
                                                    marginTop: "2px",
                                                  }}
                                                >
                                                  <i className="fa fa-map-marker" />
                                                </div>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    minWidth: 0,
                                                  }}
                                                >
                                                  {firstLine && (
                                                    <span
                                                      style={{
                                                        textOverflow:
                                                          "ellipsis",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {firstLine}
                                                    </span>
                                                  )}
                                                  {secondLine && (
                                                    <span
                                                      style={{
                                                        textOverflow:
                                                          "ellipsis",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {secondLine}
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          })()}
                                          {type === "partner" && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-users"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#fef2f2",
                                                  color: "#ef4444",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-users" />
                                              </div>
                                              <span>
                                                {item?.activeUsers || 0} Active
                                                Users
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Card 2: Key Contact Card */}
                              <div className="rt-stat-card is-large-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Key Contact
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <div
                                        className="wf-partner-left"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <div
                                          className="wf-partner-avatar is-candidate"
                                          style={{
                                            background: "#f1f5f9",
                                            color: "#475569",
                                          }}
                                        >
                                          {(partnerContactName || "")
                                            .split(" ")
                                            .filter(Boolean)
                                            .slice(0, 2)
                                            .map((w) => w[0])
                                            .join("")
                                            .toUpperCase() || "KC"}
                                        </div>
                                        {item?.contact1?.performerid && (
                                          <span className="wf-partner-avatar-id">
                                            #{item?.contact1?.performerid}
                                          </span>
                                        )}
                                      </div>
                                      <div
                                        className="wf-partner-body"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        <span
                                          className="rt-stat-value"
                                          title={partnerContactName}
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "800",
                                            color: "#0f172a",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {partnerContactName || "Not assigned"}
                                        </span>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {item?.contact1?.performeremail && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-email"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#eff6ff",
                                                  color: "#2563eb",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-envelope-o" />
                                              </div>
                                              <span
                                                style={{
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {item?.contact1?.performeremail}
                                              </span>
                                            </div>
                                          )}
                                          {item?.contact1?.contactNo && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-phone"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#fff7ed",
                                                  color: "#ea580c",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-phone" />
                                              </div>
                                              <span>
                                                {getFormatedNumber(
                                                  item?.contact1?.contactNo,
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          {item?.contact1 && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-status"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: item?.contact1
                                                    ?.isActive
                                                    ? "#ecfdf5"
                                                    : "#fff1f2",
                                                  color: item?.contact1
                                                    ?.isActive
                                                    ? "#059669"
                                                    : "#e11d48",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i
                                                  className={`fa ${item?.contact1?.isActive ? "fa-check" : "fa-clock-o"}`}
                                                />
                                              </div>
                                              <span>
                                                Status: {partnerContactStatus}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {/* Card 1: Candidate */}
                              <div className="rt-stat-card is-small-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Candidate
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <div
                                        className="wf-partner-left"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <div className="wf-partner-avatar is-candidate">
                                          {(reviewSubject || "")
                                            .split(" ")
                                            .filter(Boolean)
                                            .slice(0, 2)
                                            .map((w) => w[0])
                                            .join("")
                                            .toUpperCase() || "CN"}
                                        </div>
                                        {(item?.performerid ||
                                          candidateObj?.performerid) && (
                                            <span className="wf-partner-avatar-id">
                                              #
                                              {item?.performerid ||
                                                candidateObj?.performerid}
                                            </span>
                                          )}
                                      </div>
                                      <div
                                        className="wf-partner-body"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        <span
                                          className="rt-stat-value"
                                          title={reviewSubject}
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "800",
                                            color: "#0f172a",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {reviewSubject}
                                        </span>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {(candidateObj?.performeremail ||
                                            candidateObj?.email ||
                                            item?.performeremail ||
                                            item?.email) && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-email"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#eff6ff",
                                                    color: "#2563eb",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-envelope-o" />
                                                </div>
                                                <span
                                                  style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {candidateObj?.performeremail ||
                                                    candidateObj?.email ||
                                                    item?.performeremail ||
                                                    item?.email}
                                                </span>
                                              </div>
                                            )}
                                          {(candidateObj?.contactNo ||
                                            item?.contactNo) && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-phone"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fff7ed",
                                                    color: "#ea580c",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-phone" />
                                                </div>
                                                <span>
                                                  {getFormatedNumber(
                                                    candidateObj?.contactNo ||
                                                    item?.contactNo,
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                          {(candidateObj?.addedDateTime ||
                                            item?.addedDateTime) && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-calendar"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fef2f2",
                                                    color: "#ef4444",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-calendar-o" />
                                                </div>
                                                <span>
                                                  Joined:{" "}
                                                  <Moment format="MMM D, YYYY">
                                                    {candidateObj?.addedDateTime ||
                                                      item?.addedDateTime}
                                                  </Moment>
                                                </span>
                                              </div>
                                            )}
                                          {(() => {
                                            const getAddress = (target) => {
                                              if (!target) return null;
                                              const perfData =
                                                target.performerData;
                                              let line1 = "";
                                              let line2 = "";
                                              let city = "";
                                              let state = "";
                                              let zip = "";

                                              if (
                                                perfData &&
                                                typeof perfData === "string" &&
                                                perfData.includes(
                                                  "candidateonboardingform",
                                                )
                                              ) {
                                                try {
                                                  line1 =
                                                    getFieldData(
                                                      perfData,
                                                      "candidateonboardingform",
                                                      "Current_Address_Line1",
                                                    ) || "";
                                                  line2 =
                                                    getFieldData(
                                                      perfData,
                                                      "candidateonboardingform",
                                                      "Current_Address_Line2",
                                                    ) || "";
                                                  city =
                                                    getFieldData(
                                                      perfData,
                                                      "candidateonboardingform",
                                                      "Current_City",
                                                    ) || "";
                                                  state =
                                                    getFieldData(
                                                      perfData,
                                                      "candidateonboardingform",
                                                      "Current_State",
                                                    ) || "";
                                                  zip =
                                                    getFieldData(
                                                      perfData,
                                                      "candidateonboardingform",
                                                      "Current_Zip_Code",
                                                    ) || "";
                                                } catch (e) {
                                                  console.error(
                                                    "Error parsing performerData: ",
                                                    e,
                                                  );
                                                }
                                              }

                                              if (!line1 && !city && !state) {
                                                line1 =
                                                  target.Address_Line1 ||
                                                  target.address_Line1 ||
                                                  target.address_line1 ||
                                                  target.addressLine1 ||
                                                  "";
                                                line2 =
                                                  target.Address_Line2 ||
                                                  target.address_Line2 ||
                                                  target.address_line2 ||
                                                  target.addressLine2 ||
                                                  "";
                                                city =
                                                  target.US_City ||
                                                  target.us_City ||
                                                  target.us_city ||
                                                  target.city ||
                                                  "";
                                                state =
                                                  target.US_State ||
                                                  target.us_State ||
                                                  target.us_state ||
                                                  target.state ||
                                                  "";
                                                zip =
                                                  target.Zip_Code ||
                                                  target.zip_Code ||
                                                  target.zip_code ||
                                                  target.zipCode ||
                                                  target.zip ||
                                                  "";
                                              }

                                              if (!line1 && !city && !state)
                                                return null;

                                              return {
                                                line1,
                                                line2,
                                                city,
                                                state,
                                                zip,
                                              };
                                            };

                                            let addr = getAddress(candidateObj);
                                            if (!addr) {
                                              addr = getAddress(item);
                                            }

                                            if (!addr) return null;

                                            const firstLine = [
                                              addr.line1,
                                              addr.line2,
                                            ]
                                              .filter(Boolean)
                                              .join(", ");
                                            const secondLine = [
                                              addr.city,
                                              addr.state,
                                              addr.zip,
                                            ]
                                              .filter(Boolean)
                                              .join(", ");
                                            const fullAddressArray = [
                                              firstLine,
                                              secondLine,
                                            ].filter(Boolean);

                                            return (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                                title={[
                                                  addr.line1,
                                                  addr.line2,
                                                  addr.city,
                                                  addr.state,
                                                  addr.zip,
                                                ]
                                                  .filter(Boolean)
                                                  .join(", ")}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-address"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#f5f5f4",
                                                    color: "#78716c",
                                                    fontSize: "9px",
                                                    flexShrink: 0,
                                                  }}
                                                >
                                                  <i className="fa fa-map-marker" />
                                                </div>
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    minWidth: 0,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  {fullAddressArray.map(
                                                    (line, idx) => (
                                                      <span
                                                        key={idx}
                                                        style={{
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                        }}
                                                      >
                                                        {line}
                                                      </span>
                                                    ),
                                                  )}
                                                </span>
                                              </div>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                    {/* Action buttons removed from card to header */}
                                  </div>
                                </div>
                              </div>

                              {/* Card 2: Position & Entity */}
                              <div className="rt-stat-card is-small-card">
                                <div className="rt-stat-icon">
                                  <i
                                    className="fa fa-briefcase"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Position & Entity
                                  </span>
                                  {getProjectField("PositionTitle") ? (
                                    <span
                                      className="rt-stat-value"
                                      title={getProjectField("PositionTitle")}
                                    >
                                      {getProjectField("PositionTitle")}
                                    </span>
                                  ) : (
                                    <span
                                      className="wf-muted-text"
                                      style={{
                                        fontStyle: "italic",
                                        fontSize: "12px",
                                        color: "#94a3b8",
                                      }}
                                    >
                                      No Position Title
                                    </span>
                                  )}

                                  <div className="wf-entity-badge-row">
                                    {getOnboardingField("CandidateEntity") ? (
                                      <>
                                        {getOnboardingField(
                                          "CandidateEntity",
                                        ) === "C2C Basis" && (
                                            <span className="wf-entity-badge basis-c2c">
                                              <i className="fa fa-building-o" />{" "}
                                              C2C
                                            </span>
                                          )}
                                        {getOnboardingField(
                                          "CandidateEntity",
                                        ) === "1099 Basis" && (
                                            <span className="wf-entity-badge basis-1099">
                                              <i className="fa fa-handshake-o" />{" "}
                                              1099
                                            </span>
                                          )}
                                        {getOnboardingField(
                                          "CandidateEntity",
                                        ) === "W2 Basis" && (
                                            <span className="wf-entity-badge basis-w2">
                                              <i className="fa fa-user-circle-o" />{" "}
                                              W2{" "}
                                              {getOnboardingField("w9_Type") &&
                                                `(${getOnboardingField("w9_Type")})`}
                                            </span>
                                          )}
                                      </>
                                    ) : (
                                      <span
                                        style={{
                                          color: "#94a3b8",
                                          fontSize: "11px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        No Entity Type
                                      </span>
                                    )}
                                  </div>

                                  {item?.rates?.candidateRate ||
                                    candidateObj?.rates?.candidateRate ||
                                    getOnboardingField("Per_Diem_Rate") ? (
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                      }}
                                    >
                                      {item?.rates?.candidateRate ||
                                        candidateObj?.rates?.candidateRate ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "4px",
                                              color: "#64748b",
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#f0fdf4",
                                                color: "#16a34a",
                                                fontSize: "9px",
                                              }}
                                            >
                                              <i className="fa fa-money" />
                                            </span>
                                            Rate
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "600",
                                              color: "#1e293b",
                                            }}
                                          >
                                            <RateEncryptDecrypt
                                              rateData={
                                                item?.rates?.candidateRate ||
                                                candidateObj?.rates
                                                  ?.candidateRate
                                              }
                                            />
                                          </span>
                                        </div>
                                      ) : null}
                                      {getOnboardingField("Per_Diem_Rate") ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "4px",
                                              color: "#64748b",
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#fff1f2",
                                                color: "#e11d48",
                                                fontSize: "9px",
                                              }}
                                            >
                                              <i className="fa fa-cutlery" />
                                            </span>
                                            Per Diem
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "600",
                                              color: "#1e293b",
                                            }}
                                          >
                                            <RateEncryptDecrypt
                                              rateData={getOnboardingField(
                                                "Per_Diem_Rate",
                                              )}
                                              endSymbol="/Day"
                                            />
                                          </span>
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              {/* Card 3: Agency & Client */}
                              <div className="rt-stat-card is-small-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Agency & Client
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <div
                                        className="wf-partner-left"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="wf-agency-avatar">
                                          <i className="fa fa-handshake-o" />
                                        </div>
                                      </div>
                                      <div
                                        className="wf-partner-body"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        {getProjectField("AgencyName") ? (
                                          <span
                                            className="wf-partner-name"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "800",
                                              color: "#0f172a",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            {getProjectField("AgencyName")}
                                          </span>
                                        ) : (
                                          <span
                                            className="wf-partner-name"
                                            style={{
                                              color: "#94a3b8",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            No Agency
                                          </span>
                                        )}

                                        {getProjectValue([
                                          "ClientName",
                                          "Client_Name",
                                          "EndClient",
                                          "End_Client",
                                          "Client",
                                        ]) && (
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-client"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#eff6ff",
                                                  color: "#2563eb",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-briefcase" />
                                              </div>
                                              <span style={{ fontWeight: "500" }}>
                                                Client:
                                              </span>
                                              <span
                                                style={{
                                                  fontWeight: "600",
                                                  color: "#334155",
                                                }}
                                              >
                                                {getProjectValue([
                                                  "ClientName",
                                                  "Client_Name",
                                                  "EndClient",
                                                  "End_Client",
                                                  "Client",
                                                ])}
                                              </span>
                                            </div>
                                          )}

                                        <div
                                          className="wf-partner-info-row"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            fontSize: "11px",
                                            color: "#475569",
                                          }}
                                        >
                                          <div
                                            className="wf-identity-meta-icon wf-icon-money"
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              borderRadius: "50%",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              background: "#f0fdf4",
                                              color: "#16a34a",
                                              fontSize: "9px",
                                            }}
                                          >
                                            <i className="fa fa-money" />
                                          </div>
                                          <span style={{ fontWeight: "500" }}>
                                            Rate:
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "600",
                                              color: "#334155",
                                            }}
                                          >
                                            {item?.rates?.agencyRate ||
                                              candidateObj?.rates?.agencyRate ? (
                                              <RateEncryptDecrypt
                                                rateData={
                                                  item?.rates?.agencyRate ||
                                                  candidateObj?.rates
                                                    ?.agencyRate
                                                }
                                              />
                                            ) : (
                                              "$0.00/Hr"
                                            )}
                                          </span>
                                        </div>

                                        {getAdminAgencyFee() && (
                                          <div
                                            className="wf-partner-info-row"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                              fontSize: "11px",
                                              color: "#475569",
                                            }}
                                          >
                                            <div
                                              className="wf-identity-meta-icon wf-icon-percent"
                                              style={{
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#faf5ff",
                                                color: "#7c3aed",
                                                fontSize: "9px",
                                              }}
                                            >
                                              <i className="fa fa-percent" />
                                            </div>
                                            <span
                                              style={{
                                                fontWeight: "600",
                                                color: "#334155",
                                              }}
                                            >
                                              {getAdminAgencyFee()}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {item?.applications?.length > 0 && (
                                      <div className="wf-entity-action-bar">
                                        <div className="wf-entity-action-bar-row">
                                          <button
                                            type="button"
                                            className="wf-tool-btn is-docs"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleSummaryPopupShow(
                                                "doc_agency",
                                              );
                                            }}
                                            title="View Agency/Client Documents"
                                          >
                                            <i className="fa fa-file-text-o" />
                                            Documents
                                          </button>
                                          <button
                                            type="button"
                                            className="wf-tool-btn is-form"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleSummaryPopupShow(
                                                "form_agency",
                                              );
                                            }}
                                            title="Agency/Client Onboarding Form"
                                          >
                                            <i className="fa fa-list-alt" />
                                            View/Edit
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Card 4: Subcontractor */}
                              <div
                                className={`rt-stat-card is-small-card ${!(getOnboardingField("CandidateEntity") === "C2C Basis" && item?.subcontractor) ? "is-empty-card" : ""}`}
                              >
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Subcontractor
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      {getOnboardingField("CandidateEntity") ===
                                        "C2C Basis" && item?.subcontractor ? (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              gap: "5px",
                                            }}
                                          >
                                            <div
                                              className={`wf-partner-avatar ${item.subcontractor.useFlag ? "" : "is-inactive"}`}
                                            >
                                              {(item.subcontractor?.label || "")
                                                .split(" ")
                                                .filter(Boolean)
                                                .slice(0, 2)
                                                .map((w) => w[0])
                                                .join("")
                                                .toUpperCase() || "SC"}
                                            </div>
                                            {item.subcontractor?.fuid && (
                                              <span className="wf-partner-avatar-id">
                                                #{item.subcontractor.fuid}
                                              </span>
                                            )}
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                            }}
                                          >
                                            <div
                                              className="wf-partner-name-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                              }}
                                            >
                                              <span
                                                className="wf-partner-name"
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "800",
                                                  color: "#0f172a",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                {item.subcontractor?.label}
                                              </span>
                                              <span
                                                className={`wf-partner-status-icon ${item.subcontractor.useFlag ? "is-active" : "is-inactive"}`}
                                                title={
                                                  item.subcontractor.useFlag
                                                    ? "Active subcontractor"
                                                    : "Inactive subcontractor"
                                                }
                                              >
                                                <i
                                                  className={`fa ${item.subcontractor.useFlag ? "fa-check" : "fa-times"}`}
                                                />
                                              </span>
                                            </div>
                                            {item.subcontractor?.email && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-email"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#eff6ff",
                                                    color: "#2563eb",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-envelope-o" />
                                                </div>
                                                <span
                                                  style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {item.subcontractor.email}
                                                </span>
                                              </div>
                                            )}
                                            {getSubcontractorPhone() && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-phone"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fff7ed",
                                                    color: "#ea580c",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-phone" />
                                                </div>
                                                <span>
                                                  {getFormatedNumber(
                                                    getSubcontractorPhone(),
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-money"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#f0fdf4",
                                                  color: "#16a34a",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-money" />
                                              </div>
                                              <span
                                                style={{ fontWeight: "600" }}
                                              >
                                                {item?.rates
                                                  ?.subcontractorRate ? (
                                                  <RateEncryptDecrypt
                                                    rateData={
                                                      item.rates
                                                        .subcontractorRate
                                                    }
                                                  />
                                                ) : (
                                                  "$0.00/Hr"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              gap: "5px",
                                            }}
                                          >
                                            <div className="wf-partner-avatar is-inactive">
                                              SC
                                            </div>
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                              justifyContent: "center",
                                            }}
                                          >
                                            <span
                                              className="wf-partner-name"
                                              style={{
                                                color: "#94a3b8",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              N/A
                                            </span>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    {getOnboardingField("CandidateEntity") ===
                                      "C2C Basis" &&
                                      item?.subcontractor &&
                                      item?.applications?.length > 0 && (
                                        <div className="wf-entity-action-bar">
                                          <div className="wf-entity-action-bar-row">
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-docs"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "doc_subcontractor",
                                                );
                                              }}
                                              title="View Sub-Contractor Documents"
                                            >
                                              <i className="fa fa-file-text-o" />
                                              Documents
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-form"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "form_subcontractor",
                                                );
                                              }}
                                              title="Onboarding Form"
                                            >
                                              <i className="fa fa-list-alt" />
                                              Onboarding Form
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-po"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "po_subcontractor",
                                                );
                                              }}
                                              title="Purchase Orders"
                                            >
                                              <i className="fa fa-shopping-cart" />
                                              Purchase Order
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-ach"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(
                                                  "/ListSubcontractor/application",
                                                );
                                              }}
                                              title="View Subcontractor List"
                                            >
                                              <i className="fa fa-external-link" />
                                              View Subcontractor
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>

                              {/* Card 5: Recruiter */}
                              <div
                                className={`rt-stat-card is-small-card ${!item?.recruiter ? "is-empty-card" : ""}`}
                              >
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Recruiter
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      {item?.recruiter ? (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              gap: "5px",
                                            }}
                                          >
                                            <div
                                              className={`wf-partner-avatar is-recruiter ${item.recruiter.useFlag ? "" : "is-inactive"}`}
                                            >
                                              {(item.recruiter?.label || "")
                                                .split(" ")
                                                .filter(Boolean)
                                                .slice(0, 2)
                                                .map((w) => w[0])
                                                .join("")
                                                .toUpperCase() || "RC"}
                                            </div>
                                            {item.recruiter?.fuid && (
                                              <span className="wf-partner-avatar-id">
                                                #{item.recruiter.fuid}
                                              </span>
                                            )}
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                            }}
                                          >
                                            <div
                                              className="wf-partner-name-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                              }}
                                            >
                                              <span
                                                className="wf-partner-name"
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "800",
                                                  color: "#0f172a",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                {item.recruiter?.label}
                                              </span>
                                              <span
                                                className={`wf-partner-status-icon ${item.recruiter.useFlag ? "is-active" : "is-inactive"}`}
                                                title={
                                                  item.recruiter.useFlag
                                                    ? "Active recruiter"
                                                    : "Inactive recruiter"
                                                }
                                              >
                                                <i
                                                  className={`fa ${item.recruiter.useFlag ? "fa-check" : "fa-times"}`}
                                                />
                                              </span>
                                            </div>
                                            {item.recruiter?.email && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-email"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#eff6ff",
                                                    color: "#2563eb",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-envelope-o" />
                                                </div>
                                                <span
                                                  style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {item.recruiter.email}
                                                </span>
                                              </div>
                                            )}
                                            {getRecruiterPhone() && (
                                              <div
                                                className="wf-partner-info-row"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  fontSize: "11px",
                                                  color: "#475569",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-phone"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fff7ed",
                                                    color: "#ea580c",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-phone" />
                                                </div>
                                                <span>
                                                  {getFormatedNumber(
                                                    getRecruiterPhone(),
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-money"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#f0fdf4",
                                                  color: "#16a34a",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-money" />
                                              </div>
                                              <span
                                                style={{ fontWeight: "600" }}
                                              >
                                                {item?.rates?.recruiterRate ? (
                                                  <RateEncryptDecrypt
                                                    rateData={
                                                      item.rates.recruiterRate
                                                    }
                                                  />
                                                ) : (
                                                  "$0.00/Hr"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              gap: "5px",
                                            }}
                                          >
                                            <div className="wf-partner-avatar is-recruiter is-inactive">
                                              RC
                                            </div>
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                              justifyContent: "center",
                                            }}
                                          >
                                            <span
                                              className="wf-partner-name"
                                              style={{
                                                color: "#94a3b8",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              N/A
                                            </span>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    {item?.recruiter &&
                                      item?.applications?.length > 0 && (
                                        <div className="wf-entity-action-bar">
                                          <div className="wf-entity-action-bar-row">
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-form"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "form_recruiter",
                                                );
                                              }}
                                              title="Onboarding Form"
                                            >
                                              <i className="fa fa-list-alt" />
                                              Onboarding Form
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-po"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "po_recruiter",
                                                );
                                              }}
                                              title="Purchase Orders"
                                            >
                                              <i className="fa fa-shopping-cart" />
                                              Purchase Order
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-ach"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(
                                                  "/Recruiter/application",
                                                );
                                              }}
                                              title="View Recruiter List"
                                            >
                                              <i className="fa fa-external-link" />
                                              View Recruiter
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                              {/* Card 6: MSP */}
                              <div className="rt-stat-card is-small-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">MSP</span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      {getFieldData(
                                        item?.performerData,
                                        "candidateonboardingform",
                                        "Msp_Mode",
                                      ) ? (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                              className="wf-metric-avatar is-msp"
                                              style={{ margin: 0 }}
                                            >
                                              <i
                                                className="fa fa-sitemap"
                                                aria-hidden="true"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                            }}
                                          >
                                            <span
                                              className="rt-stat-value"
                                              title={
                                                getFieldData(
                                                  item?.performerData,
                                                  "candidateonboardingform",
                                                  "Msp_Mode",
                                                ) === "Others"
                                                  ? getFieldData(
                                                    item?.performerData,
                                                    "candidateonboardingform",
                                                    "MSP_Other_Mode",
                                                  )
                                                  : getFieldData(
                                                    item?.performerData,
                                                    "candidateonboardingform",
                                                    "Msp_Mode",
                                                  )
                                              }
                                            >
                                              {getFieldData(
                                                item?.performerData,
                                                "candidateonboardingform",
                                                "Msp_Mode",
                                              ) === "Others"
                                                ? getFieldData(
                                                  item?.performerData,
                                                  "candidateonboardingform",
                                                  "MSP_Other_Mode",
                                                )
                                                : getFieldData(
                                                  item?.performerData,
                                                  "candidateonboardingform",
                                                  "Msp_Mode",
                                                )}
                                            </span>
                                            <div
                                              className="wf-partner-info-row"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "11px",
                                                color: "#475569",
                                              }}
                                            >
                                              <div
                                                className="wf-identity-meta-icon wf-icon-percent"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                  borderRadius: "50%",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  background: "#fef3c7",
                                                  color: "#b45309",
                                                  fontSize: "9px",
                                                }}
                                              >
                                                <i className="fa fa-percent" />
                                              </div>
                                              <span
                                                style={{ fontWeight: "500" }}
                                              >
                                                Admin Fee:
                                              </span>
                                              <span
                                                style={{
                                                  fontWeight: "600",
                                                  color: "#334155",
                                                }}
                                              >
                                                {getFieldData(
                                                  item?.performerData,
                                                  "candidateonboardingform",
                                                  "Msp_AdminFee",
                                                ) ? (
                                                  <RateEncryptDecrypt
                                                    rateData={getFieldData(
                                                      item.performerData,
                                                      "candidateonboardingform",
                                                      "Msp_AdminFee",
                                                    )}
                                                    startSymbol=""
                                                    endSymbol="%"
                                                  />
                                                ) : (
                                                  "0%"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="wf-partner-left"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                              className="wf-metric-avatar is-msp is-inactive"
                                              style={{ margin: 0 }}
                                            >
                                              <i
                                                className="fa fa-sitemap"
                                                aria-hidden="true"
                                              />
                                            </div>
                                          </div>
                                          <div
                                            className="wf-partner-body"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "4px",
                                              flex: 1,
                                              minWidth: 0,
                                              justifyContent: "center",
                                            }}
                                          >
                                            <span
                                              className="wf-partner-name"
                                              style={{
                                                color: "#94a3b8",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              N/A
                                            </span>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    {getFieldData(
                                      item?.performerData,
                                      "candidateonboardingform",
                                      "Msp_Mode",
                                    ) &&
                                      item?.applications?.length > 0 && (
                                        <div className="wf-entity-action-bar">
                                          <div className="wf-entity-action-bar-row">
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-docs"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "doc_msp",
                                                );
                                              }}
                                              title="View MSP Documents"
                                            >
                                              <i className="fa fa-file-text-o" />
                                              Documents
                                            </button>
                                            <button
                                              type="button"
                                              className="wf-tool-btn is-form"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleSummaryPopupShow(
                                                  "form_msp",
                                                );
                                              }}
                                              title="MSP Onboarding Form"
                                            >
                                              <i className="fa fa-list-alt" />
                                              View/Edit
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>

                              {/* Card 7: Tech & Hub Fee */}
                              <div className="rt-stat-card is-small-card">
                                <div
                                  className="rt-stat-icon is-green"
                                  style={{
                                    alignSelf: "flex-start",
                                    marginTop: "2px",
                                  }}
                                >
                                  <i
                                    className="fa fa-calculator"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Tech & Hub Fee
                                  </span>

                                  <div
                                    style={{
                                      marginTop: "6px",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "11px",
                                        color: "#64748b",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <div
                                          className="wf-identity-meta-icon wf-icon-candidate"
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                          }}
                                        >
                                          <i className="fa fa-user-circle-o" />
                                        </div>
                                        Candidate:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#334155",
                                        }}
                                      >
                                        {item?.rates?.candidateTechFee ? (
                                          <RateEncryptDecrypt
                                            rateData={
                                              item?.rates?.candidateTechFee
                                            }
                                          />
                                        ) : (
                                          "$0.00/Hr"
                                        )}
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "11px",
                                        color: "#64748b",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          marginRight: "0.5rem",
                                        }}
                                      >
                                        <div
                                          className="wf-identity-meta-icon wf-icon-building"
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                          }}
                                        >
                                          <i className="fa fa-building-o" />
                                        </div>
                                        Subcontractor:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#334155",
                                        }}
                                      >
                                        {item?.rates?.subcontractorTechFee ? (
                                          <RateEncryptDecrypt
                                            rateData={
                                              item?.rates?.subcontractorTechFee
                                            }
                                          />
                                        ) : (
                                          "$0.00/Hr"
                                        )}
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "11px",
                                        color: "#64748b",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <div
                                          className="wf-identity-meta-icon wf-icon-recruiter"
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                          }}
                                        >
                                          <i className="fa fa-users" />
                                        </div>
                                        Recruiter:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#334155",
                                        }}
                                      >
                                        {item?.rates?.recruiterTechFee ? (
                                          <RateEncryptDecrypt
                                            rateData={
                                              item?.rates?.recruiterTechFee
                                            }
                                          />
                                        ) : (
                                          "$0.00/Hr"
                                        )}
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "11px",
                                        color: "#64748b",
                                        borderTop: "1px dashed #e2e8f0",
                                        paddingTop: "4px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <div
                                          className="wf-identity-meta-icon wf-icon-percent"
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                          }}
                                        >
                                          <i className="fa fa-percent" />
                                        </div>
                                        Hub Fee:
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#334155",
                                        }}
                                      >
                                        {getFieldData(
                                          item?.performerData,
                                          "candidateonboardingform",
                                          "Hub_CompanyFee",
                                        ) ? (
                                          <RateEncryptDecrypt
                                            rateData={getFieldData(
                                              item?.performerData,
                                              "candidateonboardingform",
                                              "Hub_CompanyFee",
                                            )}
                                            startSymbol=""
                                            endSymbol="%"
                                          />
                                        ) : (
                                          "0%"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Card 8: Duration */}
                              <div className="rt-stat-card is-small-card">
                                <div style={{ width: "100%" }}>
                                  <span className="rt-stat-label">
                                    Duration
                                  </span>
                                  <div
                                    className="wf-partner-column-stack"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      className="wf-partner-card"
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <div
                                        className="wf-partner-left"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="wf-metric-avatar is-duration">
                                          <i className="fa fa-hourglass-half" />
                                        </div>
                                      </div>
                                      <div
                                        className="wf-partner-body"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        {item?.duration !== null &&
                                          item?.duration !== undefined &&
                                          item?.duration?.duration ? (
                                          <>
                                            <span
                                              className="wf-entity-badge basis-c2c"
                                              style={{
                                                alignSelf: "flex-start",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              <i className="fa fa-hourglass-half" />{" "}
                                              {item.duration.duration} Months
                                            </span>
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "4px",
                                                marginTop: "4px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "6px",
                                                  fontSize: "11px",
                                                  color: "#64748b",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-calendar-start"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-calendar-plus-o" />
                                                </div>
                                                <span
                                                  style={{ fontWeight: "500" }}
                                                >
                                                  Start:
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "600",
                                                    color: "#334155",
                                                  }}
                                                >
                                                  <Moment format="MMM Do YYYY">
                                                    {item.duration.startDate}
                                                  </Moment>
                                                </span>
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "6px",
                                                  fontSize: "11px",
                                                  color: "#64748b",
                                                }}
                                              >
                                                <div
                                                  className="wf-identity-meta-icon wf-icon-calendar-end"
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    borderRadius: "50%",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: "9px",
                                                  }}
                                                >
                                                  <i className="fa fa-calendar-times-o" />
                                                </div>
                                                <span
                                                  style={{ fontWeight: "500" }}
                                                >
                                                  End:
                                                </span>
                                                <span
                                                  style={{
                                                    fontWeight: "600",
                                                    color: "#334155",
                                                  }}
                                                >
                                                  <Moment format="MMM Do YYYY">
                                                    {item.duration.endDate}
                                                  </Moment>
                                                </span>
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          <span
                                            className="wf-partner-name"
                                            style={{
                                              color: "#94a3b8",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            No Active Duration
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    {item?.applications?.length > 0 && (
                                      <div className="wf-entity-action-bar">
                                        <div className="wf-entity-action-bar-row">
                                          <button
                                            type="button"
                                            className="wf-tool-btn is-form"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleSummaryPopupShow(
                                                "duration",
                                              );
                                            }}
                                            title="Edit Duration"
                                          >
                                            <i className="fa fa-calendar" />
                                            Duration
                                          </button>
                                          <button
                                            type="button"
                                            className="wf-tool-btn is-ach"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleSummaryPopupShow("rate");
                                            }}
                                            title="Modify Rate"
                                          >
                                            <i className="fa fa-dollar" />
                                            Rate
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {candidateEditType === "" && item !== "" && (
              <div className="row">
                <div className="col-md-12 form-group">
                  <div
                    className={`rt-panel ${phaseClass}`}
                    ref={reviewToolsRef}
                  >
                    <div className="rt-panel-header">
                      <h2 className="rt-panel-title">
                        <i className="fa fa-wrench" aria-hidden="true" />
                        Review Tools
                        <span className="rt-panel-title-badge">
                          {
                            componentList.filter(
                              (x) =>
                                x.group === "Message" ||
                                x.group === "Interface" ||
                                x.group === "",
                            ).length
                          }
                        </span>
                      </h2>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <button
                          type="button"
                          className="rt-action-btn"
                          onClick={handleToolRefresh}
                          title="Refresh Review Tools"
                        >
                          <i className="fa fa-refresh" aria-hidden="true" />
                          Refresh
                        </button>
                        <button
                          type="button"
                          className="rt-action-btn"
                          onClick={() => setShowReviewTools(!showReviewTools)}
                          title={
                            showReviewTools
                              ? "Hide Review Tools"
                              : "Show Review Tools"
                          }
                        >
                          <i
                            className={`fa ${showReviewTools ? "fa-eye-slash" : "fa-eye"}`}
                            aria-hidden="true"
                          />
                          {showReviewTools ? "Hide Tools" : "Show Tools"}
                        </button>
                      </div>
                    </div>
                    {showReviewTools && (
                      <div className="rt-panel-body">
                        <ToolList
                          key={1}
                          compList={componentList.filter(
                            (x) =>
                              x.group === "Message" ||
                              x.group === "Interface" ||
                              x.group === "",
                          )}
                          handleToolShowHide={handleToolShowHide}
                          activeToolId={toolObj?.id}
                        />

                        <ToolsPopup
                          toolShowHide={toolShowHide}
                          handleToolShowHide={handleToolShowHide}
                          onClose={handleToolHide}
                          toolObj={toolObj}
                          item={item}
                          task={wfTask}
                          app={app}
                          candidateObj={candidateObj}
                          uploadType={uploadType}
                          setViewBprmFormShowHide={setViewBprmFormShowHide}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {candidateEditType === "" && (
              <>
                <div className="row">
                  <div className="col-md-12">
                    {workflowShowHide && (
                      <WorkflowMapPopup
                        workflowShowHide={workflowShowHide}
                        handleWorkflowModalShowHide={
                          handleWorkflowModalShowHide
                        }
                        selectedObj={currentTask}
                      ></WorkflowMapPopup>
                    )}
                  </div>
                </div>
                <div className="row">
                  <br />
                  <div className="col-md-12">
                    {app !== "" && wfTask && (
                      <TaskInfo
                        wfTask={wfTask}
                        app={app}
                        handleReAssignSubmit={handleReAssignSubmit}
                        handleShowHideSection={handleShowHideSection}
                        handleWorkflowModalShowHide={
                          handleWorkflowModalShowHide
                        }
                        workflowLabel={workflowLabel}
                      />
                    )}
                  </div>
                  <div className="col-md-12 mb-9">
                    <div
                      className={`rt-workbench-shell ${journeyShowHide ? "" : "collapsed"}`}
                    >
                      <div className="rt-workbench-container">
                        <div className="rt-journey-side">
                          <div className="rt-task-header workflow-phases">
                            <div className="rt-task-title">
                              <div className="rt-task-title-icon">
                                <i
                                  className="fa fa-road"
                                  aria-hidden="true"
                                />
                              </div>
                              {journeyShowHide && (
                                <span>Workflow Phases</span>
                              )}
                            </div>
                            <div className="rt-header-actions">
                              <button
                                className="rt-toggle-btn"
                                onClick={handleJourneyShowHide}
                                title={
                                  journeyShowHide
                                    ? "Collapse Sidebar"
                                    : "Expand Sidebar"
                                }
                              >
                                <i
                                  className={`fa ${journeyShowHide ? "fa-angle-double-left" : "fa-angle-double-right"}`}
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                          <div className="rt-journey-content">
                            <JourneySteps
                              custApp={app}
                              handleJorneySteps={handleJorneySteps}
                              handleToolShowHide={handleToolShowHide}
                              handleToolObjShowHide={handleToolObjShowHide}
                              candidateObj={candidateObj}
                              compList={componentList.filter(
                                (x) =>
                                  x.group === "Message" ||
                                  x.group === "Interface" ||
                                  x.group === "",
                              )}
                              journeyShowHide={journeyShowHide}
                              selectedTaskId={selectedTask}
                            />
                          </div>
                        </div>

                        {!app || loadingForm ? (
                          <div className="rt-main-side">
                            <div className="rt-right-skeleton-header">
                              <div className="rt-right-skeleton-icon rt-right-skeleton-pulse" />
                              <div className="rt-right-skeleton-title rt-right-skeleton-pulse" />
                            </div>
                            <div className="rt-right-skeleton-body">
                              <div className="rt-right-skeleton-row">
                                <div className="rt-right-skeleton-label rt-right-skeleton-pulse" />
                                <div className="rt-right-skeleton-field rt-right-skeleton-pulse" />
                              </div>
                              <div className="rt-right-skeleton-row">
                                <div className="rt-right-skeleton-label rt-right-skeleton-pulse" />
                                <div className="rt-right-skeleton-field rt-right-skeleton-pulse" />
                              </div>
                              <div className="rt-right-skeleton-row">
                                <div className="rt-right-skeleton-label rt-right-skeleton-pulse" />
                                <div className="rt-right-skeleton-field rt-right-skeleton-pulse" />
                              </div>
                            </div>
                          </div>
                        ) : !wfTask ? (
                          <div
                            className="rt-main-side"
                            style={{ background: "#f8fafc" }}
                          >
                            <div className="rt-right-empty-state">
                              <i
                                className="fa fa-folder-open-o rt-right-empty-icon"
                                style={{ fontSize: "40px" }}
                                aria-hidden="true"
                              />
                              <h5 className="rt-right-empty-title">
                                No Task Active
                              </h5>
                              <p className="rt-right-empty-desc">
                                Select a workflow task from the sidebar to
                                view details.
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div className="rt-main-side">
                            <div
                              className={`rt-task-header phase ${wfTask.wfPhase === "Application" ? "btn-wf2-default" : getWfPhasesColor(wfTask.wfPhase)}`}
                            >
                              <div className="rt-task-title">
                                <div className="rt-task-title-icon">
                                  <i
                                    className="fa fa-tasks"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div className="rt-task-info">
                                  <span className="rt-task-phase-name">
                                    {wfTask.wfPhase === "Application"
                                      ? "Review"
                                      : wfTask.wfPhase}
                                  </span>
                                  {wfTask.wfPhase !== "Application" && (
                                    <>
                                      <span className="rt-task-separator">
                                        /
                                      </span>
                                      <span className="rt-task-item-name">
                                        {selectedTask === 0 && toolObj?.name
                                          ? `${toolObj.name} : `
                                          : ""}
                                        {wfTask?.itemName}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="rt-header-actions">
                                <button
                                  aria-label="Refresh Journey"
                                  className="rt-refresh-link"
                                  onClick={handleRefreshJourney}
                                  title="Refresh Task & Journey"
                                >
                                  <i
                                    className="fa fa-refresh"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                            </div>
                            <div className="rt-content-scroll">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12 form-group">
                                      {selectedTask === 0 &&
                                        toolObj?.id === 1 && (
                                          <InternalReview
                                            workflowTask={currentTask}
                                          />
                                        )}
                                      {wfTask?.itemName ===
                                        "Contract Management" && (
                                          <>
                                            <div className="rt-component-actions">
                                              <button
                                                type="button"
                                                className={`btn btn-sm rt-chip-btn ${toolObj?.id === 39 ? "active" : ""}`}
                                                onClick={() =>
                                                  handleCompShowHide(39)
                                                }
                                              >
                                                <i className="fa fa-file-text-o mr-1"></i>
                                                Contract Documents
                                              </button>
                                              {entType !== "C2C Basis" && (
                                                <button
                                                  type="button"
                                                  className={`btn btn-sm rt-chip-btn ${toolObj?.id === 42 ? "active" : ""}`}
                                                  onClick={() =>
                                                    handleCompShowHide(42)
                                                  }
                                                >
                                                  <i className="fa fa-credit-card mr-1"></i>
                                                  ACH Information
                                                </button>
                                              )}
                                              {entType !== "C2C Basis" &&
                                                entType !== "W2 Basis" &&
                                                entType !== "1099 Basis" && (
                                                  <button
                                                    type="button"
                                                    className={`btn btn-sm rt-chip-btn ${toolObj?.id === 43 ? "active" : ""}`}
                                                    onClick={() =>
                                                      handleCompShowHide(43)
                                                    }
                                                  >
                                                    <i className="fa fa-shield mr-1"></i>
                                                    Insurance Information
                                                  </button>
                                                )}
                                            </div>

                                            {toolObj?.id === 39 && (
                                              <ReceivedDocuments
                                                item={item}
                                                workflowTask={currentTask}
                                              />
                                            )}

                                            {toolObj?.id === 42 && (
                                              <AchInformation
                                                workflowTask={currentTask}
                                                app={app}
                                                candidateObj={candidateObj}
                                                item={item}
                                                setViewBprmFormShowHide={
                                                  setViewBprmFormShowHide
                                                }
                                                achType={module}
                                                viewType={resolvedViewType}
                                              />
                                            )}

                                            {toolObj?.id === 43 && (
                                              <InsuranseInformation
                                                workflowTask={currentTask}
                                                app={app}
                                                candidateObj={candidateObj}
                                                item={item}
                                                setViewBprmFormShowHide={
                                                  setViewBprmFormShowHide
                                                }
                                                insuranceType={module}
                                                viewType={resolvedViewType}
                                              />
                                            )}
                                          </>
                                        )}

                                      {wfTask?.wfPhase === "Approved" &&
                                        wfTask?.formId ===
                                        config.formIds.candidate
                                          .ReportingForm && (
                                          <>
                                            <div className="rt-component-actions">
                                              <button
                                                type="button"
                                                className={`btn btn-sm rt-chip-btn ${showHideReportingDocs ? "active" : ""}`}
                                                onClick={() =>
                                                  setShowHideReportingDocs(
                                                    !showHideReportingDocs,
                                                  )
                                                }
                                              >
                                                <i className="fa fa-file-text-o mr-1"></i>
                                                Documents
                                              </button>
                                            </div>
                                            {showHideReportingDocs && (
                                              <ReportingDocuments
                                                workflowTask={currentTask}
                                                item={item}
                                              />
                                            )}
                                          </>
                                        )}

                                      {appType !== "partner" &&
                                        (wfTask?.wfPhase === "Time Log" ||
                                          wfTask?.wfPhase === "Invoice") &&
                                        !item?.partnerId && (
                                          <>
                                            <TimeLogManagement
                                              workflowTask={currentTask}
                                              app={app}
                                              candidateObj={candidateObj}
                                              item={item}
                                              pType={
                                                wfTask?.wfPhase ===
                                                  "Time Log"
                                                  ? "timelog"
                                                  : "invoice"
                                              }
                                            />
                                          </>
                                        )}

                                      {appType === "partner" &&
                                        (wfTask?.wfPhase === "Time Log" ||
                                          wfTask?.wfPhase === "Invoice") &&
                                        item?.partnerId > 0 && (
                                          <SubRecCandidates
                                            workflowTask={wfTask}
                                            app={app}
                                            candidateObj={candidateObj}
                                            item={item}
                                            pType={
                                              wfTask?.wfPhase === "Time Log"
                                                ? "timelog"
                                                : "invoice"
                                            }
                                            module={module}
                                            appType={appType}
                                            procType={procType}
                                            parentApplication={parentApp}
                                            currentTask={currentTask}
                                          />
                                        )}
                                    </div>
                                  </div>

                                  {wfForm &&
                                    wfTask.wfPhase !== "Application" && (
                                      <WorkflowElement
                                        wfTask={wfTask}
                                        wfForm={wfForm}
                                        handleNextTask={handleNextTask}
                                        actionType={"workflow"}
                                        viewType={
                                          currentUser?.type === "admin"
                                            ? false
                                            : String(
                                              wfTask?.performerId,
                                            ) ===
                                              String(currentUser?.id)
                                              ? false
                                              : true
                                        }
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

